// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T21:34:40.208Z
// Property: Creekside Village (ID: 6767906449166804)
// Collections: 19 amenities, 6 floorplans (live), 86 photos, 28 POIs, 3 reviews, 2 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166804",
  "property_external_id": "481CSV",
  "property_zillow_url": "https://www.zillow.com/apartments/vancouver-wa/creekside-village/5XkGQP/",
  "property_apartments_url": "https://www.apartments.com/creekside-village-vancouver-wa/gz3plsw/",
  "property_google_business_url": "https://www.google.com/maps/place/Creekside+Village/data=!4m2!3m1!1s0x0:0x26703d4cbadaa7af?sa=X&ved=2ahUKEwj21Nnc56eSAxXZsFYBHaatJO8Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40343719840",
  "property_crm_software": null,
  "property_pm_software": "AIM",
  "property_pm_info": "481CSV",
  "property_status": null,
  "property_slug": "creekside-village",
  "property_name": "Creekside Village",
  "property_website_url": "https://www.liveatcreeksidevillage.com/",
  "property_domain": "https://www.liveatcreeksidevillage.com/",
  "property_address": "3100 Falk Road",
  "property_full_address": "3100 Falk Rd, Vancouver, WA 98661",
  "property_address_1": "3100 Falk Rd",
  "property_address_2": null,
  "property_address_city": "Vancouver",
  "property_address_state": "WA",
  "property_address_zip_full": "98661",
  "property_address_zip": "98661",
  "property_address_country": "US",
  "property_address_county": "Clark County",
  "property_neighborhood_address": "Bagley Downs",
  "property_address_latitude": "45.6436727",
  "property_address_longitude": "-122.6299125",
  "property_email": "csvmgr@amcllc.net",
  "property_phone": "(360) 383-5932",
  "property_call_tracking_phone": "855-369-0369",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Creekside Village in Vancouver, WA, where your dream home awaits! Choose from spacious two- or three-bedroom layouts, all featuring modern amenities like quartz countertops, stainless steel appliances, and community perks like a refreshing pool and fitness center. Experience comfort, convenience, and community—your perfect lifestyle begins here!",
  "property_long_description": "Welcome to Creekside Village, the perfect blend of comfort, convenience, and modern living in the heart of Vancouver, WA. Our thoughtfully designed two and three-bedroom floor plans cater to a variety of lifestyles, ensuring you find the ideal space for your needs. Each apartment comes equipped with luxurious features including stainless steel appliances, quartz countertops, and spacious walk-in closets, all set against a backdrop of stylish vinyl flooring and carpets.\n\nAt Creekside Village, we believe that community matters. Enjoy the sun by our sparkling pool, stay active in our state-of-the-art fitness center, or unwind at our inviting clubhouse. Children can have a blast at the playground, while our dog park and pet play area ensure that your furry friends feel right at home. With convenient amenities like maintenance and property management on-site, package services, and door-to-door trash pickup, your living experience will be hassle-free.\n\nStay connected with community-wide Wi-Fi and high-speed internet access, ensuring that both work and play are seamless. Our smoke-free environment, key fob entry, and sprinkler systems provide peace of mind and security for all residents.\n\nDiscover the vibrant lifestyle that awaits you at Creekside Village. Whether you’re savoring a quiet evening by your fireplace, enjoying the outdoors on your private patio, or working from your designated office space, you’ll find the perfect balance of relaxation and convenience. \n\nDon’t wait! Find your new home today—browse our availability or schedule a tour to explore our beautiful community. Welcome to your future at Creekside Village!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-6699-74a8-b0b1-d8ac2ff1f33f.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with townhomes in the background.",
    "public_id": "019f3953-6699-74a8-b0b1-d8ac2ff1f33f",
    "storage_key": "property/6767906449166804/019f3953-6699-74a8-b0b1-d8ac2ff1f33f.webp",
    "width": 3072,
    "height": 2049
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166804/01a1a34d-93c3-7404-a885-166a5c3e2be5.mp4",
  "property_featured_video_media": {
    "public_id": "01a1a34d-93c3-7404-a885-166a5c3e2be5",
    "storage_key": "property/6767906449166804/01a1a34d-93c3-7404-a885-166a5c3e2be5.mp4",
    "thumbnail_key": "property/6767906449166804/01a1a34d-93c3-7404-a885-166a5c3e2be5_thumb.webp",
    "size_bytes": 70767773,
    "classification": "Community",
    "title": "Explore Our Community Amenities: Pool, Gym, and More!",
    "description": "Discover the exceptional amenities at our apartment community, including a sparkling pool, a state-of-the-art fitness center, and a resident lounge. Experience the best in apartment living."
  },
  "property_total_units": "132",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.72727272727273",
  "property_admin_fee": "300",
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Dogs and cats are welcome (no weight limit), with a maximum of 2 pets per apartment. Breed restrictions apply.",
  "property_pet_policy_description": "Dogs and cats are welcome (no weight limit), with a maximum of 2 pets per apartment. Breed restrictions apply. Pet fee: $300 per pet. Pet rent: $35 per pet, per month.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://www.myrentalapplication.com/index/creeksidevillage-csv",
  "property_resident_portal_url": "https://creeksidevillage.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/creeksidevillage-csv",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d0-e6bb-747e-aeea-b48bd489e758.webp",
  "property_primary_logo_media": {
    "alt_text": "Creekside Village logo",
    "public_id": "019d02d0-e6bb-747e-aeea-b48bd489e758",
    "storage_key": "property/6767906449166804/019d02d0-e6bb-747e-aeea-b48bd489e758.webp",
    "width": 182,
    "height": 71
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d0-e6bb-747e-aeea-b48bd489e758.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Creekside Village logo",
    "public_id": "019d02d0-e6bb-747e-aeea-b48bd489e758",
    "storage_key": "property/6767906449166804/019d02d0-e6bb-747e-aeea-b48bd489e758.webp",
    "width": 182,
    "height": 71
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d0-e6bb-747e-aeea-b48bd489e758.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Creekside Village logo",
    "public_id": "019d02d0-e6bb-747e-aeea-b48bd489e758",
    "storage_key": "property/6767906449166804/019d02d0-e6bb-747e-aeea-b48bd489e758.webp",
    "width": 182,
    "height": 71
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#111111",
  "property_secondary_color": "#1EC2FF",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2 - 3",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1,016 - 10,161,452 sq ft",
  "property_sqft_min": "1,016",
  "property_sqft_max": "1452",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/creeksidevillageapts/",
  "property_instagram_url": "https://www.instagram.com/creeksidevillagevancouver/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ7ybzFWyvlVQRr6faukw9cCY",
  "property_youtube_url": "https://www.youtube.com/watch?v=ez-IADTS0Dc",
  "property_yelp_url": "https://www.yelp.com/biz/creekside-village-apartments-by-conam-management-vancouver",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Creekside Village",
  "property_home_romance_title": "Find Your Happy Place at Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Creekside Village in Vancouver, WA—where comfort meets convenience. Unwind in our scenic community or take advantage of top-notch amenities designed for your lifestyle. With stylish apartment layouts and exceptional services, your ideal home awaits amidst nature’s beauty. Embrace the vibrant living experience you deserve today!",
  "property_home_floorplans_blurb": "Welcome to Creekside Village in vibrant Vancouver, WA, where comfort meets style in every thoughtfully designed floor plan. Our community offers a serene escape with modern amenities, inviting you to unwind and connect. Browse our available apartment homes today and uncover your ideal space that reflects your unique lifestyle!",
  "property_home_gallery_blurb": "Welcome to Creekside Village in Vancouver, WA, where vibrant community features and modern apartment amenities blend harmoniously. Enjoy spacious floor plans, serene outdoor spaces, and exceptional services that cater to your lifestyle. Picture yourself living here, surrounded by comfort and convenience in a welcoming neighborhood. Your dream home awaits!",
  "property_home_neighborhood_blurb": "Welcome to Creekside Village in Vancouver, WA, where spacious two and three-bedroom homes offer comfort in a vibrant community. Nestled near educational institutions like Clark College and Roosevelt Elementary, you'll find a rich tapestry of local culture and enriching opportunities just steps away. See what's around our community and explore local favorites!",
  "property_home_reviews_blurb": "At Creekside Village in Vancouver, WA, residents rave about the serenity of our lush landscape and welcoming atmosphere. One happy tenant shares, \"Living here feels like a retreat!\" Experience the charm for yourself and see what our residents have to say about life in this vibrant community!",
  "property_neighborhood_blurb": "At Creekside Village in Vancouver, WA, you’ll find spacious two and three-bedroom homes surrounded by a vibrant educational landscape. With top-notch schools like Clark College and Roosevelt Elementary just minutes away, envision a life where learning and community thrive. Dive into the local fabric—uncover nearby parks, schools, and more!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Creekside Village in Vancouver, WA, where modern living meets comfort. Dive into a refreshing pool, stay fit in our state-of-the-art fitness center, or unwind in the inviting clubhouse. With spacious two and three-bedroom floor plans, abundant amenities, and a welcoming community atmosphere, your ideal home awaits!",
  "property_applynow_blurb": "Welcome to Creekside Village in Vancouver, WA, where modern living meets comfort. Choose from spacious two or three-bedroom floor plans featuring luxurious quartz countertops, high-speed internet, and a pet-friendly dog park. Enjoy resort-style amenities like a refreshing pool, fitness center, and clubhouse. Find your new home and lease online today!",
  "property_contactus_blurb": "At Creekside Village in Vancouver, WA, our spacious two and three-bedroom floor plans are designed for comfort and style. Imagine vibrant living spaces tailored to your needs. Curious about our apartments? Our leasing team is eager to assist. Reach out today and start your journey to the perfect home!",
  "property_faqs_blurb": "At Creekside Village in Vancouver, WA, our spacious two and three-bedroom floor plans cater to your lifestyle. Whether you're seeking room to grow or a stylish retreat, we have the perfect fit for you. Visit our FAQs page to uncover what makes our community truly exceptional!",
  "property_floorplans_blurb": "At Creekside Village in Vancouver, WA, our thoughtfully designed two and three-bedroom floor plans cater to your unique lifestyle. Revel in spacious layouts that blend comfort and modern living. Browse our available apartment homes today and uncover the perfect space that reflects your personality and elevates your everyday experience.",
  "property_gallery_blurb": "At Creekside Village in Vancouver, WA, vibrant living comes alive. Imagine lounging by the pool, staying fit in our state-of-the-art fitness center, or enjoying quality time in our spacious dog park. Each two and three-bedroom apartment features modern amenities, including high-speed internet and cozy fireplaces. Picture yourself living here!",
  "property_interactivemap_blurb": "At Creekside Village in beautiful Vancouver, WA, your dream apartment awaits! Choose from spacious two or three-bedroom floor plans, each designed for comfort and convenience. With amenities like a refreshing pool, state-of-the-art fitness center, and a welcoming dog park, life here is truly a retreat. Dive into our interactive community map to envision your future home today!",
  "property_pets_blurb": "At Creekside Village in Vancouver, WA, your furry friends are part of the family! Enjoy spacious living with no weight limits on dogs and cats, plus a serene community backdrop. With plenty of green spaces to explore, your pets will thrive as you create lasting memories together.",
  "property_referafriend_blurb": "At Creekside Village in Vancouver, WA, our spacious two and three-bedroom floor plans offer the perfect blend of comfort and style. Elevate your living experience by sharing it with friends! Great friends make great neighbors—refer a friend to our community today and grow your circle in a vibrant setting.",
  "property_residentaccess_blurb": "At Creekside Village in Vancouver, WA, our spacious two- and three-bedroom floor plans are designed for comfort and style. Enjoy convenient living with easy access to our resident portal for seamless rent payments, maintenance requests, and a host of amenities. Elevate your community experience today!",
  "property_reviews_blurb": "At Creekside Village in Vancouver, WA, residents cherish the vibrant sense of community and serene surroundings. One resident raves, \"Living here feels like being part of a welcoming family!\" Dive into our reviews and see what makes Creekside Village the perfect place to call home!",
  "property_created_at": "1762201302275",
  "property_scheduletour_blurb": "At Creekside Village in Vancouver, WA, our spacious two- and three-bedroom floor plans cater to your lifestyle needs. Experience the harmony of modern living surrounded by nature. Curious about life here? Hear firsthand from our residents! Schedule a tour today and envision your new home among the trees.",
  "property_thankyou_blurb": "Thank you for your interest in Creekside Village in beautiful Vancouver, WA. With spacious two and three-bedroom floor plans, your ideal living space awaits. A team member will reach out soon to guide you in finding your perfect home at our vibrant community. Enjoy the journey to your new lifestyle!",
  "property_virtualtours_blurb": "At Creekside Village in Vancouver, WA, our thoughtfully designed two and three-bedroom apartments cater to your unique lifestyle. Immerse yourself in our vibrant community with a virtual tour that reveals the perfect blend of comfort, style, and convenience. Experience home like never before—take your virtual tour today! ",
  "property_copyright": "2025 All Rights Reserved. Creekside Village",
  "property_seo_title_home": "Creekside Village |  Apartments in Vancouver, WA",
  "property_seo_description_home": "Welcome to Creekside Village in Vancouver, WA! Explore spacious 2- and 3-bedroom apartments with a pool, fitness center, and dog park.",
  "property_seo_title_floorplans": "Floor Plans | Vancouver, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Creekside Village in Vancouver, WA! Browse our unique two and three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Vancouver, WA Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Creekside Village in Vancouver, WA! Enjoy luxurious amenities like a pool, fitness center, dog park, and stylish apartments. Live your best life!",
  "property_seo_title_gallery": "Gallery | Apartments in Vancouver, WA",
  "property_seo_description_gallery": "Discover Creekside Village in Vancouver, WA. Explore our photo gallery and imagine your new life by the pool in a spacious, serene home!",
  "property_seo_title_virtualtours": "Virtual Tours | Creekside Village Apartments",
  "property_seo_description_virtualtours": "Step into Creekside Village in Vancouver, WA! Experience stunning two and three-bedroom apartments. Take a virtual tour today and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Creekside Village Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Creekside Village in Vancouver, WA. Utilize our interactive map to explore spacious floor plans, amenities, and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Vancouver, WA",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood of Creekside Village in Vancouver, WA. Dive into local favorites and nearby attractions that make life extraordinary!",
  "property_seo_title_contact": "Contact Us | Creekside Village",
  "property_seo_description_contact": "Connect with Creekside Village in Vancouver, WA! Whether you’re eyeing a 2-bedroom or 3-bedroom apartment, our friendly leasing team is here to help you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Vancouver, WA",
  "property_seo_description_faqs": "Get the answers you need about Creekside Village in Vancouver, WA! Explore our FAQs to discover life-enhancing amenities and spacious floor plans.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Vancouver, WA",
  "property_seo_description_reviews": "At Creekside Village in Vancouver, WA, our residents share their genuine experiences. Dive into community life and see why they love calling us home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Vancouver, WA",
  "property_seo_description_applynow": "Find your perfect home at Creekside Village in Vancouver, WA! Enjoy spacious two & three-bedroom apartments with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Creekside Village",
  "property_seo_description_residentaccess": "Log in to your Creekside Village portal for rent payments, maintenance requests, and community updates in Vancouver, WA!",
  "property_seo_title_referafriend": "Refer A Friend | Creekside Village",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Creekside Village in Vancouver, WA, and enjoy the perks of community living together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Creekside Village",
  "property_seo_description_scheduletour": "Experience the charm of Creekside Village in Vancouver, WA. Schedule a tour today and imagine your lifestyle in our vibrant, welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Creekside Village",
  "property_seo_description_privacy": "At Creekside Village in Vancouver, WA, your privacy is our priority. Learn how we protect your personal information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Creekside Village",
  "property_seo_description_accessibility": "At Creekside Village in Vancouver, WA, we prioritize accessibility for all. Join us in fostering a community where everyone is welcome and included!",
  "property_seo_title_sitemap": "Sitemap | Creekside Village",
  "property_seo_description_sitemap": "Navigate Creekside Village in Vancouver, WA! Check out our sitemap to easily explore our vibrant community and find your perfect home today.",
  "property_seo_title_thankyou": "Thank You | Creekside Village",
  "property_seo_description_thankyou": "Thank you for reaching out to Creekside Village in Vancouver, WA! A team member will be in touch soon to help you find your perfect home nestled by nature.",
  "property_seo_title_pets": "Pet Policy | Apartments in Vancouver, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793741194907",
  "amenities": [
    {
      "id": "custom_78f6dc2d-6646-475c-bd4e-dd271b8961ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "High End Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ef46cb9e-f83c-40cf-a2c8-47248ee14f20",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and dryer in unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b0c2f75-2408-4dc4-9dee-f988bb3c12b0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Large bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_13140371-90ee-433a-a84d-98c991a7267b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-in closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76dbd29a-62d0-4323-828e-a14c8ba9a76c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54cdd320-7c38-4269-a92a-c7724c911d72",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Pre installed high speed internet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ccd4aa72-82f6-491c-a8c9-177373ee4003",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Covered parking",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d15f949e-d5c6-4da2-b985-45bfdd19a2d8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Attached garage * ",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_97689264-736e-454f-a003-ee82854374bd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony / Patio *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_32f5f0cf-7f97-4ca6-a86f-c8f0a6eca87a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Air conditioning *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_75aa7a29-2c79-423c-a1ac-4a9802c03586",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool ",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_348befe3-3ef3-46b7-9726-2980a736cad4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5225d822-4482-48b5-908c-42debebadd84",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e27de14-c51a-41f5-95ba-8cadbda0ea9b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9384c03-b3fa-4703-a217-71cdd5a1f5d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubhouse / Gameroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02c81b0e-edca-4907-8dd7-02932a62f279",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab120594-d9ef-4df3-84a9-46990148f41a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc2ed462-cdd6-43dc-a73c-ecd1b92bbb0b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a25138da-9b8d-433a-aa5c-8100708b0e6b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "external_id": "false",
      "title": "Valet trash pickup",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_1770760d-2310-44ce-b8a1-32fc75ab1406",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-6699-74a8-b0b1-d8ac2ff1f33f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with townhomes in the background at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-6699-74a8-b0b1-d8ac2ff1f33f",
        "storage_key": "property/6767906449166804/019f3953-6699-74a8-b0b1-d8ac2ff1f33f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush greenery and modern townhomes.",
      "link": "",
      "alt_text": "Outdoor swimming pool with townhomes in the background at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e432f1c1-9cc0-4199-849e-49a7265b62a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-1ea8-7059-a710-126bf6b770a1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, dining tables, and red umbrellas at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-1ea8-7059-a710-126bf6b770a1",
        "storage_key": "property/6767906449166804/019f3953-1ea8-7059-a710-126bf6b770a1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool in our community's outdoor oasis, complete with comfortable seating and shaded areas.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, dining tables, and red umbrellas at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b5d5829-e509-4c1c-b92c-491cdd0f2c78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-2e97-7448-8faf-594bb2aee117.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019f3953-2e97-7448-8faf-594bb2aee117",
        "storage_key": "property/6767906449166804/019f3953-2e97-7448-8faf-594bb2aee117.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush greenery and comfortable seating for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ab83d9c-0139-4b1c-8e9f-2b9af0f9e062",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-acbf-71fe-90d8-4f4664ed64f4.webp",
      "image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and umbrellas, set against apartment buildings and lush trees at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-acbf-71fe-90d8-4f4664ed64f4",
        "storage_key": "property/6767906449166804/019f3953-acbf-71fe-90d8-4f4664ed64f4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge seating and vibrant greenery.",
      "link": "",
      "alt_text": "An inviting outdoor swimming pool with lounge chairs and umbrellas, set against apartment buildings and lush trees at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c5d61c27-984d-4dd7-bbc1-4affa1cd90e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-4d22-779b-b3ef-f855eea69ed8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a red umbrella at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-4d22-779b-b3ef-f855eea69ed8",
        "storage_key": "property/6767906449166804/019f3953-4d22-779b-b3ef-f855eea69ed8.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded umbrella for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a red umbrella at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d676947-17f4-498c-bcce-fa2dc904497e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-6ee9-735b-ad47-661a27164e38.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs, a hot tub, and a gazebo at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-6ee9-735b-ad47-661a27164e38",
        "storage_key": "property/6767906449166804/019f3953-6ee9-735b-ad47-661a27164e38.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, or relax in the soothing hot tub. The adjacent gazebo and lounge area provide the perfect spot for sunbathing and unwinding.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs, a hot tub, and a gazebo at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_44bb42a2-0881-4123-97d8-0667525e1e6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1f2b-747a-b087-8f0bfc719255.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool at dusk with apartment buildings in the background at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-1f2b-747a-b087-8f0bfc719255",
        "storage_key": "property/6767906449166804/019f3954-1f2b-747a-b087-8f0bfc719255.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our outdoor swimming pool, perfectly situated amidst the serene beauty of our community, especially magical at dusk.",
      "link": "",
      "alt_text": "Outdoor swimming pool at dusk with apartment buildings in the background at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_47752e82-fa16-43d7-8aba-4c42ed0c467e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-6376-7090-bf62-6274f0d1e8e7.webp",
      "image_media": {
        "alt_text": "Built-in stainless steel grill with a concrete countertop and wooden base, next to lounge chairs at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-6376-7090-bf62-6274f0d1e8e7",
        "storage_key": "property/6767906449166804/019f3953-6376-7090-bf62-6274f0d1e8e7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our spacious built-in grill area, perfect for resident gatherings. Features a large stainless steel grill and comfortable seating.",
      "link": "",
      "alt_text": "Built-in stainless steel grill with a concrete countertop and wooden base, next to lounge chairs at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a4c9e5a-d256-49e0-bd5a-4b2d69ff61d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-a8a2-77d7-849a-41c789c8a8fb.webp",
      "image_media": {
        "alt_text": "Playground area with slides, climbing structures, and swings at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-a8a2-77d7-849a-41c789c8a8fb",
        "storage_key": "property/6767906449166804/019f3953-a8a2-77d7-849a-41c789c8a8fb.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for playing and exploring.",
      "link": "",
      "alt_text": "Playground area with slides, climbing structures, and swings at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8354c44-1c08-43b3-bab0-886914e37348",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-606b-75cb-82f6-9b0dc011292e.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and benches at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-606b-75cb-82f6-9b0dc011292e",
        "storage_key": "property/6767906449166804/019f3953-606b-75cb-82f6-9b0dc011292e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Our pet-friendly community features a dedicated dog park with agility equipment for your furry friends to enjoy.",
      "link": "",
      "alt_text": "Dog park with agility equipment and benches at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_940db6bd-8ed9-43ef-82e1-ee940065a5ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-e24e-7028-8e7f-599a502c97a8.webp",
      "image_media": {
        "alt_text": "Playground with slide and climbing structure in a park-like setting at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-e24e-7028-8e7f-599a502c97a8",
        "storage_key": "property/6767906449166804/019f3953-e24e-7028-8e7f-599a502c97a8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring a slide and climbing equipment for children.",
      "link": "",
      "alt_text": "Playground with slide and climbing structure in a park-like setting at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_158ccf37-686c-4339-b7db-52277c45119e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1eea-705e-8e1e-f720eb271681.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with a fireplace, large TV, leather couch, and bar seating.",
        "public_id": "019f3954-1eea-705e-8e1e-f720eb271681",
        "storage_key": "property/6767906449166804/019f3954-1eea-705e-8e1e-f720eb271681.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish communal lounge, featuring a cozy fireplace, entertainment center, comfortable seating, and a convenient bar area with views of the surrounding neighborhood.",
      "link": "",
      "alt_text": "Modern communal lounge area with a fireplace, large TV, leather couch, and bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d58bbad-1dbb-41c1-b1e2-fe48d4aa10e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-a790-74aa-bbd1-4913ec0a1fc2.webp",
      "image_media": {
        "alt_text": "Community lounge with foosball table, ping pong table, fireplace, and seating area at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-a790-74aa-bbd1-4913ec0a1fc2",
        "storage_key": "property/6767906449166804/019f3953-a790-74aa-bbd1-4913ec0a1fc2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy fun and games in the community lounge, featuring a foosball table, ping pong table, cozy fireplace, and comfortable seating.",
      "link": "",
      "alt_text": "Community lounge with foosball table, ping pong table, fireplace, and seating area at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_90eb2f8e-6f26-4860-8527-65f2c2ae8fa9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-9874-7169-bfb1-fcc3d9b8a6a3.webp",
      "image_media": {
        "alt_text": "Community lounge with foosball, ping pong, kitchenette, and seating area at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-9874-7169-bfb1-fcc3d9b8a6a3",
        "storage_key": "property/6767906449166804/019f3953-9874-7169-bfb1-fcc3d9b8a6a3.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy fun and games in our vibrant community lounge, featuring a kitchenette, foosball, ping pong table, and comfortable seating areas.",
      "link": "",
      "alt_text": "Community lounge with foosball, ping pong, kitchenette, and seating area at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_909bcc1a-48a7-4158-83db-d56bfcf51a17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1c1e-753d-a385-42a3b160eeec.webp",
      "image_media": {
        "alt_text": "Coffee bar with coffee maker, refrigerator, and seating area at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-1c1e-753d-a385-42a3b160eeec",
        "storage_key": "property/6767906449166804/019f3954-1c1e-753d-a385-42a3b160eeec.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks at our convenient coffee bar, perfect for a quick pick-me-up.",
      "link": "",
      "alt_text": "Coffee bar with coffee maker, refrigerator, and seating area at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0eaa76c8-5a4a-4575-845b-8ee83f925c5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-6e24-73b4-991e-7ecbb5d45be9.webp",
      "image_media": {
        "alt_text": "Gaming room with an arcade game, a comic book mural, and skateboards on the wall at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-6e24-73b4-991e-7ecbb5d45be9",
        "storage_key": "property/6767906449166804/019f3953-6e24-73b4-991e-7ecbb5d45be9.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in our vibrant gaming room, featuring a classic arcade machine, eye-catching comic book mural, and cool skateboard decor.",
      "link": "",
      "alt_text": "Gaming room with an arcade game, a comic book mural, and skateboards on the wall at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e25c97a-02c3-42c5-817f-21db40f1ed2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1444-72da-b641-bdba072851c0.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, dumbbells, kettlebells, and a bench at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-1444-72da-b641-bdba072851c0",
        "storage_key": "property/6767906449166804/019f3954-1444-72da-b641-bdba072851c0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with modern weight machines, free weights, and cardio equipment.",
      "link": "",
      "alt_text": "Gym with weight machines, dumbbells, kettlebells, and a bench at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c10e647-7da1-408e-98fb-02325ff08932",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-73a2-77da-8072-54771e874b3e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and recumbent bikes.",
        "public_id": "019f3953-73a2-77da-8072-54771e874b3e",
        "storage_key": "property/6767906449166804/019f3953-73a2-77da-8072-54771e874b3e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, fully equipped with cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and recumbent bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e0fcbd52-b8d3-4aa1-9c54-7a94f9357f21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-745a-7411-8e60-8fe0eed873c8.webp",
      "image_media": {
        "alt_text": "Interior of a fitness center with treadmills, ellipticals, and exercise bikes, featuring a large mirror wall at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-745a-7411-8e60-8fe0eed873c8",
        "storage_key": "property/6767906449166804/019f3953-745a-7411-8e60-8fe0eed873c8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, ellipticals, and other cardio machines to help you reach your wellness goals.",
      "link": "",
      "alt_text": "Interior of a fitness center with treadmills, ellipticals, and exercise bikes, featuring a large mirror wall at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b887ce67-b11f-4e4e-b2d1-a087c10dcdf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-4360-7453-86cd-2adc955ff9f0.webp",
      "image_media": {
        "alt_text": "Modern fitness center with weight machines, dumbbells, and a TV at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-4360-7453-86cd-2adc955ff9f0",
        "storage_key": "property/6767906449166804/019f3953-4360-7453-86cd-2adc955ff9f0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art weight machines, a wide selection of dumbbells, and a mounted TV for your entertainment.",
      "link": "",
      "alt_text": "Modern fitness center with weight machines, dumbbells, and a TV at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cbfc6bf5-da96-4916-b26f-3454b03e696c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-412e-732d-abc3-d70c96032335.webp",
      "image_media": {
        "alt_text": "Creekside Village package lockers featuring a mountain landscape at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-412e-732d-abc3-d70c96032335",
        "storage_key": "property/6767906449166804/019f3953-412e-732d-abc3-d70c96032335.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Secure package lockers with a scenic mountain mural at the entrance to Creekside Village apartments.",
      "link": "",
      "alt_text": "Creekside Village package lockers featuring a mountain landscape at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0dca1a3-3d90-4977-b82b-ae84dca8c32e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-4c25-71ce-816b-a94bdac92fc4.webp",
      "image_media": {
        "alt_text": "Apartment complex with trees and a parking lot at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-4c25-71ce-816b-a94bdac92fc4",
        "storage_key": "property/6767906449166804/019f3953-4c25-71ce-816b-a94bdac92fc4.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Exterior view of an apartment complex, showcasing buildings, covered parking, and lush green trees on a sunny day.",
      "link": "",
      "alt_text": "Apartment complex with trees and a parking lot at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4ecd32d-70e6-4bb8-a8a5-d7995d8b1cb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1912-761f-8f2d-e5fa877da0fe.webp",
      "image_media": {
        "alt_text": "Townhomes with garages and cars parked in front under trees at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-1912-761f-8f2d-e5fa877da0fe",
        "storage_key": "property/6767906449166804/019f3954-1912-761f-8f2d-e5fa877da0fe.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Exterior view of townhome units featuring attached garages and parking spaces. Lush trees provide shade over the property.",
      "link": "",
      "alt_text": "Townhomes with garages and cars parked in front under trees at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_88ad5540-ece3-4ab3-9795-c82ef3e6d2f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-1a95-741b-9509-d97d839f1cdb.webp",
      "image_media": {
        "alt_text": "Townhomes with garages and manicured landscaping.",
        "public_id": "019f3953-1a95-741b-9509-d97d839f1cdb",
        "storage_key": "property/6767906449166804/019f3953-1a95-741b-9509-d97d839f1cdb.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of townhomes featuring attached garages and beautiful green landscaping. Enjoy a comfortable and convenient living experience in this community.",
      "link": "",
      "alt_text": "Townhomes with garages and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1ba7eee-b3c8-49a6-af13-eaba30f5eed0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-598f-7581-a3a3-0cf56d3cb77c.webp",
      "image_media": {
        "alt_text": "Row of townhome apartments with garages and parked cars at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-598f-7581-a3a3-0cf56d3cb77c",
        "storage_key": "property/6767906449166804/019f3953-598f-7581-a3a3-0cf56d3cb77c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of townhome apartments, featuring individual garages and driveways. The complex is surrounded by mature trees and lush greenery under a bright blue sky.",
      "link": "",
      "alt_text": "Row of townhome apartments with garages and parked cars at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f2bf1ff-819d-4369-8343-f55001638b33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-bc53-74ba-ab4b-fc12246d7f8b.webp",
      "image_media": {
        "alt_text": "Townhouse apartment buildings with garages and parked cars.",
        "public_id": "019f3953-bc53-74ba-ab4b-fc12246d7f8b",
        "storage_key": "property/6767906449166804/019f3953-bc53-74ba-ab4b-fc12246d7f8b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Townhouse apartment exteriors with garages and manicured landscaping, offering a comfortable and convenient living experience.",
      "link": "",
      "alt_text": "Townhouse apartment buildings with garages and parked cars.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c933662c-4214-471f-a8ff-2c27d9e688bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-990d-777d-9363-ed8ffabde691.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with garages and mature trees at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-990d-777d-9363-ed8ffabde691",
        "storage_key": "property/6767906449166804/019f3953-990d-777d-9363-ed8ffabde691.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Beautifully maintained apartment complex exterior featuring blue and grey buildings with attached garages and lush green trees providing ample shade.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with garages and mature trees at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c91446ce-1044-42cf-ae10-75f2cda60404",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-4e06-715f-a556-702729d0b75c.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with covered parking and trees.",
        "public_id": "019f3953-4e06-715f-a556-702729d0b75c",
        "storage_key": "property/6767906449166804/019f3953-4e06-715f-a556-702729d0b75c.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings, showcasing the architecture and surrounding greenery. Features covered parking spaces for residents.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with covered parking and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f1470bc-c2e8-4630-8c75-3f80612ec5ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-45fe-74ce-bd82-53a6c1c32b09.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with blue and gray siding and white staircases at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-45fe-74ce-bd82-53a6c1c32b09",
        "storage_key": "property/6767906449166804/019f3953-45fe-74ce-bd82-53a6c1c32b09.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Exterior view of a multi-story apartment building featuring blue and gray siding, with prominent white outdoor staircases and balconies. Reserved parking is available under a covered structure.",
      "link": "",
      "alt_text": "Exterior view of apartment building with blue and gray siding and white staircases at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_900cf318-4206-4a48-9bff-f8c43f098eb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-cc3a-76b2-a92f-c096a6f37880.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and trees at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-cc3a-76b2-a92f-c096a6f37880",
        "storage_key": "property/6767906449166804/019f3953-cc3a-76b2-a92f-c096a6f37880.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Aerial view of apartment buildings showcasing the exterior architecture and surrounding lush greenery.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages and trees at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_81d72827-f9de-4218-a913-d04138629ac1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-7f7d-711c-97ca-36495074c958.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with attached garages and surrounding trees.",
        "public_id": "019f3953-7f7d-711c-97ca-36495074c958",
        "storage_key": "property/6767906449166804/019f3953-7f7d-711c-97ca-36495074c958.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Experience comfortable living in these charming apartment buildings, complete with convenient attached garages and a picturesque, tree-lined neighborhood.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with attached garages and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c84337e-5810-447e-8d41-8e7d7aec955b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-82b6-72e5-a4fe-c683d3378c8f.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding trees at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-82b6-72e5-a4fe-c683d3378c8f",
        "storage_key": "property/6767906449166804/019f3953-82b6-72e5-a4fe-c683d3378c8f.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing apartment buildings nestled amidst lush greenery, with distant mountains on the horizon.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding trees at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_384daf85-c33e-4fde-bde5-a22548b56f3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-c47a-7563-953e-7c96087ee8e0.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a central outdoor swimming pool and surrounding trees at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-c47a-7563-953e-7c96087ee8e0",
        "storage_key": "property/6767906449166804/019f3953-c47a-7563-953e-7c96087ee8e0.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover resort-style living with our beautiful outdoor swimming pool, surrounded by lush greenery and well-maintained grounds. Enjoy a refreshing dip or relax by the poolside.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a central outdoor swimming pool and surrounding trees at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_42e7f6a0-b9e2-4a6a-943e-265c76423500",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-c2b2-71cd-93fa-78f4cbbf5d4a.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounded by lush trees at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-c2b2-71cd-93fa-78f4cbbf5d4a",
        "storage_key": "property/6767906449166804/019f3953-c2b2-71cd-93fa-78f4cbbf5d4a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "An aerial perspective showcases the apartment complex nestled amongst a dense forest, highlighting the exterior architecture and natural surroundings.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounded by lush trees at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8222782-41d8-4fb2-a52e-1821dfad9223",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-1e55-71ed-928f-1d4eb348618a.webp",
      "image_media": {
        "alt_text": "Creekside Village monument sign with landscaping in Vancouver, WA.",
        "public_id": "019f3953-1e55-71ed-928f-1d4eb348618a",
        "storage_key": "property/6767906449166804/019f3953-1e55-71ed-928f-1d4eb348618a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Welcome to Creekside Village, a beautiful apartment community. This monument sign is surrounded by colorful flowers and lush greenery.",
      "link": "",
      "alt_text": "Creekside Village monument sign with landscaping in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_236742f9-4e94-43c2-a4b7-1a84dda8fc20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1bb1-76ad-a9c4-77ac94f0f041.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and light wood cabinets at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-1bb1-76ad-a9c4-77ac94f0f041",
        "storage_key": "property/6767906449166804/019f3954-1bb1-76ad-a9c4-77ac94f0f041.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample counter space, and sleek cabinetry. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and light wood cabinets at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5d65f4d5-81fd-4d2e-bc4a-2e9931d5df18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-94c6-77a4-9d1f-7f569e8360b8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, stainless steel appliances, and white countertops at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-94c6-77a4-9d1f-7f569e8360b8",
        "storage_key": "property/6767906449166804/019f3953-94c6-77a4-9d1f-7f569e8360b8.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring light wood cabinetry, sleek white countertops, and stainless steel appliances, perfect for home chefs.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets, stainless steel appliances, and white countertops at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_67522331-a0a3-476a-a52c-530436795313",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-9a29-767c-953c-319e45f35f55.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinetry at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-9a29-767c-953c-319e45f35f55",
        "storage_key": "property/6767906449166804/019f3953-9a29-767c-953c-319e45f35f55.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "This apartment kitchen features stainless steel appliances, ample storage with light wood cabinets, and a sleek countertop with a modern faucet.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinetry at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2bfacf32-52af-4ea6-97e9-4da822862eb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-141f-74ff-b624-a2cff61bc544.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and dishwasher, living room with fireplace and large windows at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-141f-74ff-b624-a2cff61bc544",
        "storage_key": "property/6767906449166804/019f3953-141f-74ff-b624-a2cff61bc544.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a spacious island with a deep sink and stainless steel dishwasher, flowing into a comfortable living area with a cozy fireplace and ample natural light.",
      "link": "",
      "alt_text": "Kitchen island with sink and dishwasher, living room with fireplace and large windows at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be2d80ac-beec-4a93-8fcf-d36edecc038f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-2ac9-758a-a16a-db84e5bd1b89.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinetry at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-2ac9-758a-a16a-db84e5bd1b89",
        "storage_key": "property/6767906449166804/019f3954-2ac9-758a-a16a-db84e5bd1b89.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet space, and a breakfast bar.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinetry at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0c26ea3-b195-4173-b275-e70aaf4230de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-3b37-76b8-893b-43ba35b5db17.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, white countertops, and stainless steel appliances at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-3b37-76b8-893b-43ba35b5db17",
        "storage_key": "property/6767906449166804/019f3954-3b37-76b8-893b-43ba35b5db17.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A bright and contemporary kitchen featuring ample cabinet space, sleek countertops, and a pass-through to the living area. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets, white countertops, and stainless steel appliances at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2861499-dcb8-46e3-b6cf-94847c5bbde8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-f795-741e-a2b4-5ec409ad023a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and ample cabinet space  at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-f795-741e-a2b4-5ec409ad023a",
        "storage_key": "property/6767906449166804/019f3953-f795-741e-a2b4-5ec409ad023a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring stainless steel appliances, light wood cabinets, and a large island, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and ample cabinet space  at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed5b8e21-1085-4630-bbae-8e661537a352",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-1af1-72a7-a4df-4d5bbc7cbf67.webp",
      "image_media": {
        "alt_text": "Modern apartment living room and kitchen with stainless steel appliances and breakfast bar at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-1af1-72a7-a4df-4d5bbc7cbf67",
        "storage_key": "property/6767906449166804/019f3954-1af1-72a7-a4df-4d5bbc7cbf67.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area seamlessly flowing into a contemporary kitchen, featuring stainless steel appliances, ample cabinet space, and a convenient breakfast bar for casual dining.",
      "link": "",
      "alt_text": "Modern apartment living room and kitchen with stainless steel appliances and breakfast bar at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_373fb7ea-30a1-4fcb-9116-160e9756a2d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-338e-7799-99ad-281460577096.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a ceiling fan at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-338e-7799-99ad-281460577096",
        "storage_key": "property/6767906449166804/019f3954-338e-7799-99ad-281460577096.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, a ceiling fan, and large windows with natural light.",
      "link": "",
      "alt_text": "Living room with a fireplace and a ceiling fan at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86ff9163-ba64-4d96-83a0-0d06c0108471",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-8e8a-72fe-abc4-062162a03b02.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and sliding glass doors at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-8e8a-72fe-abc4-062162a03b02",
        "storage_key": "property/6767906449166804/019f3953-8e8a-72fe-abc4-062162a03b02.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, large sliding glass doors leading to the outdoors, and a modern ceiling fan.",
      "link": "",
      "alt_text": "Living room with fireplace and sliding glass doors at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_69575959-dc5a-448f-ada6-1aaeb2a38ebc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-938f-7050-8207-35c84970d95e.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace and an open-concept kitchen at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-938f-7050-8207-35c84970d95e",
        "storage_key": "property/6767906449166804/019f3953-938f-7050-8207-35c84970d95e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy this open-concept living space, perfect for entertaining, featuring a cozy fireplace and a modern kitchen.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace and an open-concept kitchen at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3bca14a5-0217-4b21-8e81-84e3dcf3947c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-d92e-71cd-932d-f5e027b78f5f.webp",
      "image_media": {
        "alt_text": "Spacious living room with a fireplace and sliding glass doors leading to a backyard at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-d92e-71cd-932d-f5e027b78f5f",
        "storage_key": "property/6767906449166804/019f3953-d92e-71cd-932d-f5e027b78f5f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cozy evenings in this spacious living room, complete with a charming fireplace and ample natural light. Step outside through the sliding glass doors to a private backyard oasis.",
      "link": "",
      "alt_text": "Spacious living room with a fireplace and sliding glass doors leading to a backyard at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_73733dfa-b28b-4b0a-912d-015618efcddd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-d315-732e-837f-afcc00c3d4a0.webp",
      "image_media": {
        "alt_text": "Spacious living room with a gas fireplace and large windows overlooking trees at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-d315-732e-837f-afcc00c3d4a0",
        "storage_key": "property/6767906449166804/019f3953-d315-732e-837f-afcc00c3d4a0.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy up by the gas fireplace in this inviting living room, featuring large windows that let in abundant natural light and offer beautiful views of the surrounding greenery.",
      "link": "",
      "alt_text": "Spacious living room with a gas fireplace and large windows overlooking trees at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6149327-b08f-4f2e-b904-188be745d959",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-3dd2-72ba-9ce9-cb9748a4f8d1.webp",
      "image_media": {
        "alt_text": "Interior view of a staircase with a white banister and a closet at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-3dd2-72ba-9ce9-cb9748a4f8d1",
        "storage_key": "property/6767906449166804/019f3954-3dd2-72ba-9ce9-cb9748a4f8d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Interior view of a staircase featuring a white banister and a spacious closet, offering a glimpse into the apartment's design.",
      "link": "",
      "alt_text": "Interior view of a staircase with a white banister and a closet at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60ff2504-a1b1-4d60-9961-daecef2ac0b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-e4e0-721a-9a7f-7da629d78591.webp",
      "image_media": {
        "alt_text": "Interior staircase with white banister and neutral carpeted steps, leading down to a hallway at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-e4e0-721a-9a7f-7da629d78591",
        "storage_key": "property/6767906449166804/019f3953-e4e0-721a-9a7f-7da629d78591.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and airy interior staircase featuring a white banister and neutral carpeted steps. This staircase leads down to a hallway with a window offering a glimpse of the outdoors.",
      "link": "",
      "alt_text": "Interior staircase with white banister and neutral carpeted steps, leading down to a hallway at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9411d405-7208-4202-ae14-b26029c16aef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-1641-741b-b9b6-731ac28ab5c5.webp",
      "image_media": {
        "alt_text": "Interior staircase with white railings and doors in a modern apartment at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-1641-741b-b9b6-731ac28ab5c5",
        "storage_key": "property/6767906449166804/019f3953-1641-741b-b9b6-731ac28ab5c5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Bright and airy interior staircase featuring white railings and doors, leading to the upper level of the apartment. The wood-look flooring adds warmth.",
      "link": "",
      "alt_text": "Interior staircase with white railings and doors in a modern apartment at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0e40a842-b476-4b65-b941-dd53893ff693",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-34bf-70cc-a9df-f9ae43f2a0e2.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a window and blinds at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-34bf-70cc-a9df-f9ae43f2a0e2",
        "storage_key": "property/6767906449166804/019f3954-34bf-70cc-a9df-f9ae43f2a0e2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A neutral-toned bedroom featuring soft carpeting and a large window, perfect for personalization.",
      "link": "",
      "alt_text": "Empty bedroom with a window and blinds at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_34c2546d-0736-4cf1-af75-14f767b7f87b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-a35a-72cf-af49-b344edce0256.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral carpet and a window overlooking trees at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-a35a-72cf-af49-b344edce0256",
        "storage_key": "property/6767906449166804/019f3953-a35a-72cf-af49-b344edce0256.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "This empty bedroom features neutral carpeting and a large window that allows natural light to fill the space. The view from the window offers a glimpse of lush greenery.",
      "link": "",
      "alt_text": "Empty bedroom with neutral carpet and a window overlooking trees at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b9337ac-d468-487e-9ac0-e9ed24397689",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-4787-749a-bd15-30c4d8398469.webp",
      "image_media": {
        "alt_text": "Empty bedroom with neutral-colored walls and carpet, and two windows at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-4787-749a-bd15-30c4d8398469",
        "storage_key": "property/6767906449166804/019f3953-4787-749a-bd15-30c4d8398469.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom with ample natural light and plush carpeting. Ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with neutral-colored walls and carpet, and two windows at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_228866a7-fcae-4e2f-9e96-8c138e7befdd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-3fa5-77b4-8871-b4ec1a7be070.webp",
      "image_media": {
        "alt_text": "Empty room with neutral carpet and cream walls, two windows with blinds at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-3fa5-77b4-8871-b4ec1a7be070",
        "storage_key": "property/6767906449166804/019f3953-3fa5-77b4-8871-b4ec1a7be070.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and bright living area featuring neutral carpeting and soft cream walls, perfect for personalizing your home. Ample natural light flows in through two large windows.",
      "link": "",
      "alt_text": "Empty room with neutral carpet and cream walls, two windows with blinds at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_91b794d6-465f-4b03-9af6-f0b02d60a7b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-08d3-779a-9ec8-9b28b70f77ae.webp",
      "image_media": {
        "alt_text": "Bedroom with a mirror, closet and doorway to hallway at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-08d3-779a-9ec8-9b28b70f77ae",
        "storage_key": "property/6767906449166804/019f3954-08d3-779a-9ec8-9b28b70f77ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large closet with mirrored doors and plush carpeting. An open doorway reveals access to the hallway.",
      "link": "",
      "alt_text": "Bedroom with a mirror, closet and doorway to hallway at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_abcc6254-d5a0-4b5d-8e26-fd8838bbf103",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-3f47-761a-9b18-1eaa085ca95d.webp",
      "image_media": {
        "alt_text": "Bedroom with vanity and bathroom entrance at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-3f47-761a-9b18-1eaa085ca95d",
        "storage_key": "property/6767906449166804/019f3953-3f47-761a-9b18-1eaa085ca95d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a plush carpet, large window with blinds, and a connected vanity area with a mirror and ample lighting. A doorway leads to the bathroom.",
      "link": "",
      "alt_text": "Bedroom with vanity and bathroom entrance at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01ca34ed-cd31-47fc-99bb-44900cfdf685",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-799c-74d8-b626-db21bcc59907.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, toilet, and vanity with a large mirror at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-799c-74d8-b626-db21bcc59907",
        "storage_key": "property/6767906449166804/019f3953-799c-74d8-b626-db21bcc59907.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Freshen up in this stylish bathroom featuring a spacious walk-in shower, modern vanity, and ample counter space.",
      "link": "",
      "alt_text": "Modern bathroom with a walk-in shower, toilet, and vanity with a large mirror at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3bf0d0e3-28ba-40ef-8e33-c469adc99777",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-452f-77ac-b32c-af2ddbe78636.webp",
      "image_media": {
        "alt_text": "Vanity with sink and large mirror, adjacent to a sliding-door closet at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-452f-77ac-b32c-af2ddbe78636",
        "storage_key": "property/6767906449166804/019f3953-452f-77ac-b32c-af2ddbe78636.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious vanity area with a modern sink and ample counter space, perfect for getting ready. Includes a large mirror and a convenient sliding door closet for storage.",
      "link": "",
      "alt_text": "Vanity with sink and large mirror, adjacent to a sliding-door closet at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df731042-8929-406c-bf2f-0ed0873d677c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-8d63-7059-8fcc-4a61e000e7d2.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, mirror, and a bathtub with a toilet at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-8d63-7059-8fcc-4a61e000e7d2",
        "storage_key": "property/6767906449166804/019f3953-8d63-7059-8fcc-4a61e000e7d2.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into this clean and modern bathroom, featuring a spacious vanity with ample counter space, a bright mirror, and a convenient bathtub and toilet combo. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, mirror, and a bathtub with a toilet at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9094167d-e55d-4e52-a130-cd157e18451e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-93ed-71bb-b3c8-8fb097bc46c7.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and toilet at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-93ed-71bb-b3c8-8fb097bc46c7",
        "storage_key": "property/6767906449166804/019f3953-93ed-71bb-b3c8-8fb097bc46c7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "A modern apartment bathroom featuring a vanity with a white countertop and sink, wood-look cabinetry, and a toilet.",
      "link": "",
      "alt_text": "Bathroom vanity with sink and toilet at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5ce043ac-7a7b-4421-83f6-fea3afeeb407",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-05be-71d8-9e80-4167023ae278.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, large mirror, and white tub/shower combo at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-05be-71d8-9e80-4167023ae278",
        "storage_key": "property/6767906449166804/019f3954-05be-71d8-9e80-4167023ae278.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Update your daily routine in this stylish bathroom featuring a spacious vanity with ample counter space, a large mirror, and a pristine white tub and shower combination.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, large mirror, and white tub/shower combo at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d4b51245-6fd1-4da1-affc-53b86a832ac0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-37f4-714a-982c-c774d65ffb05.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, large mirror, and bathtub/shower combo at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-37f4-714a-982c-c774d65ffb05",
        "storage_key": "property/6767906449166804/019f3954-37f4-714a-982c-c774d65ffb05.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into a clean and inviting bathroom featuring a spacious vanity with ample counter space, a large mirror, and a pristine bathtub and shower combination, perfect for relaxing.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, large mirror, and bathtub/shower combo at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_81ca28ea-6ae9-443c-9155-00325a175323",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-189d-706d-b7d8-75bd26ca1075.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet and bathroom entrance at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-189d-706d-b7d8-75bd26ca1075",
        "storage_key": "property/6767906449166804/019f3954-189d-706d-b7d8-75bd26ca1075.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet and a glimpse into a modern bathroom with a toilet and shower. Ample storage and convenient bathroom access.",
      "link": "",
      "alt_text": "Spacious walk-in closet and bathroom entrance at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60efae10-8752-459e-b4d6-fae7f93de951",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-177d-76fd-bb33-c357c7cf6096.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry closet with shelving at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-177d-76fd-bb33-c357c7cf6096",
        "storage_key": "property/6767906449166804/019f3954-177d-76fd-bb33-c357c7cf6096.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry services.",
      "link": "",
      "alt_text": "Washer and dryer in laundry closet with shelving at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1113f1ba-8ba0-4d8c-9530-777df5050966",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-225e-72e0-8b67-f36534ec02af.webp",
      "image_media": {
        "alt_text": "Washer and dryer with water heater and HVAC unit at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-225e-72e0-8b67-f36534ec02af",
        "storage_key": "property/6767906449166804/019f3954-225e-72e0-8b67-f36534ec02af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer with water heater and HVAC unit for your convenience.",
      "link": "",
      "alt_text": "Washer and dryer with water heater and HVAC unit at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d188f18-f375-4759-8449-953220e6393d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3954-252e-750c-aee0-be63ee29e562.webp",
      "image_media": {
        "alt_text": "Empty white garage with washer and dryer at Creekside Village in Vancouver, WA.",
        "public_id": "019f3954-252e-750c-aee0-be63ee29e562",
        "storage_key": "property/6767906449166804/019f3954-252e-750c-aee0-be63ee29e562.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer located in your private garage.",
      "link": "",
      "alt_text": "Empty white garage with washer and dryer at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92b77b58-eb76-4428-8601-e44bdc56f4bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019f3953-5c7e-743d-b015-31166c9e6207.webp",
      "image_media": {
        "alt_text": "Private backyard patio with a wooden fence and a mature tree providing shade at Creekside Village in Vancouver, WA.",
        "public_id": "019f3953-5c7e-743d-b015-31166c9e6207",
        "storage_key": "property/6767906449166804/019f3953-5c7e-743d-b015-31166c9e6207.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Enjoy your own private outdoor space with this charming backyard patio, enclosed by a beautiful wooden fence. A mature tree offers shade and a touch of nature to your serene retreat.",
      "link": "",
      "alt_text": "Private backyard patio with a wooden fence and a mature tree providing shade at Creekside Village in Vancouver, WA.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_df34f2a5-ecf2-44f1-9074-2d36e5f9551d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-343a-701a-8227-75af8e40e6b6.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed and a tropical beach painting above it.",
        "public_id": "019d02d1-343a-701a-8227-75af8e40e6b6",
        "storage_key": "property/6767906449166804/019d02d1-343a-701a-8227-75af8e40e6b6.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in our spacious bedrooms, featuring a plush king-size bed and serene decor. The room is accented with a tropical beach painting, creating a tranquil ambiance.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed and a tropical beach painting above it.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6161bd8-20c9-4176-9356-ea3b14f0c5cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-2e98-75a6-bee2-59f518f66796.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, a nightstand with a lamp, and a window with blinds.",
        "public_id": "019d02d1-2e98-75a6-bee2-59f518f66796",
        "storage_key": "property/6767906449166804/019d02d1-2e98-75a6-bee2-59f518f66796.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, a sleek nightstand with a lamp, and a window offering natural light.",
      "link": "",
      "alt_text": "Bedroom with a large bed, a nightstand with a lamp, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7cc62845-ea3c-4172-b7f9-5ce3b2db9f64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-29d3-7168-bde7-4444192faeb0.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstands, and a window with greenery outside.",
        "public_id": "019d02d1-29d3-7168-bde7-4444192faeb0",
        "storage_key": "property/6767906449166804/019d02d1-29d3-7168-bde7-4444192faeb0.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Comfortable and inviting bedroom featuring a spacious bed, stylish nightstands, and a large window offering views of lush greenery. Perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a large bed, nightstands, and a window with greenery outside.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb46003c-1579-4c99-b732-f7ea897f97eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-23f3-704e-af9c-3e7964b4beb5.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstands, a closet with mirrored doors, and a framed artwork on the wall.",
        "public_id": "019d02d1-23f3-704e-af9c-3e7964b4beb5",
        "storage_key": "property/6767906449166804/019d02d1-23f3-704e-af9c-3e7964b4beb5.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Cozy and spacious bedroom featuring a comfortable bed, elegant decor, and ample closet space with mirrored doors.",
      "link": "",
      "alt_text": "Bedroom with a large bed, nightstands, a closet with mirrored doors, and a framed artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85beeebd-b943-4902-af83-dd3fef2a2ac0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-2322-711e-a043-9173cb25e19a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a single vanity, large mirror, and a separate toilet and tub/shower combo.",
        "public_id": "019d02d1-2322-711e-a043-9173cb25e19a",
        "storage_key": "property/6767906449166804/019d02d1-2322-711e-a043-9173cb25e19a.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Step into a bright and spacious bathroom featuring a sleek vanity with ample counter space and a large mirror. The separate toilet and tub/shower combo offer convenience and privacy.",
      "link": "",
      "alt_text": "Modern bathroom with a single vanity, large mirror, and a separate toilet and tub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c7227f4-b661-4fd6-ada2-33d6574c8523",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-2004-7135-93ee-b6403ab1bffe.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a coffee station, mini-fridge, and seating area.",
        "public_id": "019d02d1-2004-7135-93ee-b6403ab1bffe",
        "storage_key": "property/6767906449166804/019d02d1-2004-7135-93ee-b6403ab1bffe.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy a fresh cup of coffee from our convenient coffee station, located near the seating area and mini-fridge. Perfect for a quick refreshment.",
      "link": "",
      "alt_text": "Modern kitchen with a coffee station, mini-fridge, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b6396a8-3e6b-4506-a8b8-3b47b7c9ef97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-1a41-7414-9902-54187933b983.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and hallway",
        "public_id": "019d02d1-1a41-7414-9902-54187933b983",
        "storage_key": "property/6767906449166804/019d02d1-1a41-7414-9902-54187933b983.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring plush carpeting, a large closet, and access to a hallway with additional storage.",
      "link": "",
      "alt_text": "Bedroom with closet and hallway",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_796191d5-964b-469b-bbc7-31f5e4d243b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-16e4-71ae-bf9f-644cd193e56d.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and access to another room.",
        "public_id": "019d02d1-16e4-71ae-bf9f-644cd193e56d",
        "storage_key": "property/6767906449166804/019d02d1-16e4-71ae-bf9f-644cd193e56d.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring mirrored closet doors and plush carpeting. An adjacent doorway offers a glimpse into another area of the apartment.",
      "link": "",
      "alt_text": "Bedroom with mirrored closet doors and access to another room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2bc436fd-03c8-49ba-aa84-858fe9b60ebb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-1922-710c-a274-63a67d17c55d.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dining table in an apartment.",
        "public_id": "019d02d1-1922-710c-a274-63a67d17c55d",
        "storage_key": "property/6767906449166804/019d02d1-1922-710c-a274-63a67d17c55d.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen area featuring a dining table, comfortable seating, and modern appliances, perfect for everyday living and entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area with dining table in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc8b8b97-5848-45da-a349-09bf7ad715b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-0f93-742f-abd0-885c12a1b352.webp",
      "image_media": {
        "alt_text": "Interior view of a hallway with a closet and stairs.",
        "public_id": "019d02d1-0f93-742f-abd0-885c12a1b352",
        "storage_key": "property/6767906449166804/019d02d1-0f93-742f-abd0-885c12a1b352.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious hallway featuring a large closet with shelves and a staircase with a white railing.",
      "link": "",
      "alt_text": "Interior view of a hallway with a closet and stairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e72c860-22e4-4029-b213-9fe7d862ae4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-0e4b-755f-a717-960a697e1cea.webp",
      "image_media": {
        "alt_text": "Open-concept living and kitchen area with a fireplace and dining table.",
        "public_id": "019d02d1-0e4b-755f-a717-960a697e1cea",
        "storage_key": "property/6767906449166804/019d02d1-0e4b-755f-a717-960a697e1cea.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy the spacious open-concept layout featuring a modern kitchen, comfortable living area with a fireplace, and a dedicated dining space.",
      "link": "",
      "alt_text": "Open-concept living and kitchen area with a fireplace and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f46e31cb-af67-4a63-83a6-b7cdc647459d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-0c9e-751d-a8b0-069cc0a254b3.webp",
      "image_media": {
        "alt_text": "Interior staircase with carpeted steps and white banisters.",
        "public_id": "019d02d1-0c9e-751d-a8b0-069cc0a254b3",
        "storage_key": "property/6767906449166804/019d02d1-0c9e-751d-a8b0-069cc0a254b3.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "A bright and clean interior staircase featuring carpeted steps and white wooden banisters, leading towards a hallway with an open door.",
      "link": "",
      "alt_text": "Interior staircase with carpeted steps and white banisters.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_644fb53b-f479-4216-9aca-110855813ec0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-01ca-75b6-b801-2bfee41d8033.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, ample cabinet space, and a large island with a sink.",
        "public_id": "019d02d1-01ca-75b6-b801-2bfee41d8033",
        "storage_key": "property/6767906449166804/019d02d1-01ca-75b6-b801-2bfee41d8033.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and functionality in our modern kitchens, featuring sleek cabinetry, stainless steel appliances, and spacious countertops for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, ample cabinet space, and a large island with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7a3c3c4-4518-44da-81e3-310b12c083de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-0442-71cd-890c-04d3d3bff2a4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, white countertops, stainless steel appliances, and a large sink.",
        "public_id": "019d02d1-0442-71cd-890c-04d3d3bff2a4",
        "storage_key": "property/6767906449166804/019d02d1-0442-71cd-890c-04d3d3bff2a4.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring light wood cabinetry, sleek white countertops, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with light wood cabinets, white countertops, stainless steel appliances, and a large sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78e19147-c895-447f-a31d-cb755451fd75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-0208-717f-98af-659545b6b20b.webp",
      "image_media": {
        "alt_text": "Living room and dining area with fireplace and large sectional sofa.",
        "public_id": "019d02d1-0208-717f-98af-659545b6b20b",
        "storage_key": "property/6767906449166804/019d02d1-0208-717f-98af-659545b6b20b.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a cozy fireplace, a comfortable sectional sofa, and ample natural light. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with fireplace and large sectional sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dce691a0-1737-44d9-b0a1-e17013c48b17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d0-f961-77e7-b915-8069c316f224.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with stairs",
        "public_id": "019d02d0-f961-77e7-b915-8069c316f224",
        "storage_key": "property/6767906449166804/019d02d0-f961-77e7-b915-8069c316f224.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious living area flowing into a modern kitchen with stainless steel appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Living room and kitchen area with stairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2e272e8-7ecb-4525-96f3-6e71cce1c430",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d0-f6f0-7704-8ba0-ed95a50f6bf0.webp",
      "image_media": {
        "alt_text": "Open concept living area with kitchen and dining space",
        "public_id": "019d02d0-f6f0-7704-8ba0-ed95a50f6bf0",
        "storage_key": "property/6767906449166804/019d02d0-f6f0-7704-8ba0-ed95a50f6bf0.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area seamlessly flows into a modern kitchen and dining space, perfect for entertaining.",
      "link": "",
      "alt_text": "Open concept living area with kitchen and dining space",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f41c14d5-a289-4ff9-916e-8770b4d019fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d0-f64c-74cd-8fef-8d250db6608e.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sliding glass door, and a large window.",
        "public_id": "019d02d0-f64c-74cd-8fef-8d250db6608e",
        "storage_key": "property/6767906449166804/019d02d0-f64c-74cd-8fef-8d250db6608e.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, abundant natural light from a large window, and direct access to an outdoor patio or yard.",
      "link": "",
      "alt_text": "Living room with a fireplace, sliding glass door, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ec3d4038-de97-4fa8-9179-18630f0de0b5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Clark College Community and Continuing Education",
      "poi_type": "Education",
      "poi_address": "18700 SE Mill Plain Blvd, Vancouver, WA 98683, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-1aa1-725c-89dd-dcc056bbac76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-1aa1-725c-89dd-dcc056bbac76",
        "storage_key": "property/6767906449166804/01a0b628-1aa1-725c-89dd-dcc056bbac76.webp",
        "width": 620,
        "height": 429
      },
      "poi_business_url": "https://ecd.clark.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1998807428779096819&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clark-college-community-and-continuing-education",
      "poi_latitude": "45.616214",
      "poi_longitude": "-122.482139",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-992-2939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e905-77bb-bd56-b5565a33d413.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e905-77bb-bd56-b5565a33d413",
        "storage_key": "property/6767906449166804/019d02d1-e905-77bb-bd56-b5565a33d413.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJudXa6oullVQR8zrKLsQwvRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b8256992-e2e4-40d8-9213-b549cfe11daf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "MedVet Vancouver",
      "poi_type": "Health and Wellness",
      "poi_address": "2913 NE 72nd Dr, Vancouver, WA 98661, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2145-765a-b626-6cc924e56d40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2145-765a-b626-6cc924e56d40",
        "storage_key": "property/6767906449166804/01a0b628-2145-765a-b626-6cc924e56d40.webp",
        "width": 1025,
        "height": 1025
      },
      "poi_business_url": "https://www.medvet.com/location/vancouver/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1598567263450720831&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "medvet-vancouver",
      "poi_latitude": "45.643711",
      "poi_longitude": "-122.598607",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-839-2704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-ef1d-73dd-87d4-11d2d76b7172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ef1d-73dd-87d4-11d2d76b7172",
        "storage_key": "property/6767906449166804/019d02d1-ef1d-73dd-87d4-11d2d76b7172.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-0J-9oevlVQRP2qM33RALxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e835a0b5-0c8c-4c0a-9970-fbbc61c0f246",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Vancouver VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1601 E 4th Plain Blvd, Vancouver, WA 98661, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2030-779c-8f77-08f31dfe4b06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2030-779c-8f77-08f31dfe4b06",
        "storage_key": "property/6767906449166804/01a0b628-2030-779c-8f77-08f31dfe4b06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9959607596450288720&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vancouver-va-medical-center",
      "poi_latitude": "45.6375722",
      "poi_longitude": "-122.6581484",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-759-1901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-f5d2-75bc-8aba-e753345ff6ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-f5d2-75bc-8aba-e753345ff6ed",
        "storage_key": "property/6767906449166804/019d02d1-f5d2-75bc-8aba-e753345ff6ed.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJaYiUwG6vlVQRUJSzOFeiN4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1fb630d9-0be1-48d9-837d-d1690594fe5f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2101 NE Andresen Rd, Vancouver, WA 98661, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this grocery store offers excellent prices on a wide selection of fresh produce, meat, and bulk items, and is open 24 hours. They also highlight the friendly and helpful staff, and the clean, well-organized store.\n\nSome reviews mention the service can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-1f5b-7319-a88e-38b724977fc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-1f5b-7319-a88e-38b724977fc8",
        "storage_key": "property/6767906449166804/01a0b628-1f5b-7319-a88e-38b724977fc8.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7497084975423100577&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "45.63892000000001",
      "poi_longitude": "-122.597278",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-397-5501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e92e-717e-99f7-b136fcc9f8e9",
        "storage_key": "property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWE6XYCvlVQRoRYDWxD_Cmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_8717557c-223f-43fe-a397-258a471ab5c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "7809 NE Vancouver Plaza Dr Suite #100, Vancouver, WA 98662, USA",
      "poi_short_description": "Recreation center with trampolines and other attractions such as go-karts, bumper cars, and a zip line.",
      "poi_long_description": "People say this amusement park offers a wide variety of fun activities for kids, including go-karts and trampolines, and many find it to be a good value for the price.\n\nOther reviews mention attractions can be out of order and staff can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2083-72ff-85d0-26d0eebb495f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2083-72ff-85d0-26d0eebb495f",
        "storage_key": "property/6767906449166804/01a0b628-2083-72ff-85d0-26d0eebb495f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/washington-vancouver/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=13110182597549849209&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "45.6477501",
      "poi_longitude": "-122.5931186",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-559-2327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-ef1d-73dd-87d4-11d2d76b7172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ef1d-73dd-87d4-11d2d76b7172",
        "storage_key": "property/6767906449166804/019d02d1-ef1d-73dd-87d4-11d2d76b7172.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7eYxc8mvlVQReXp3m5y58LU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_356a7ded-09a8-453a-a8eb-2e8c8b55f726",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Pearson Air Museum",
      "poi_type": "Entertainment",
      "poi_address": "1115 E 5th St, Vancouver, WA 98661, USA",
      "poi_short_description": "Large hanger has World War I-era planes on display plus an exhibit on the first transpolar flight.",
      "poi_long_description": "Visitors say this air museum offers a rich history of early aviation and features beautiful old airplanes, including unique antique biplanes and prototypes. They also highlight the interactive activities, such as building gliders and climbing inside planes, and appreciate the spotless restrooms. Guests mention the museum is free to enter and provides an educational experience for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d2-3f65-76f0-953e-d9f129c52308.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02d2-3f65-76f0-953e-d9f129c52308",
        "storage_key": "property/6767906449166804/019d02d2-3f65-76f0-953e-d9f129c52308.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nps.gov/fova/planyourvisit/pearsonairmuseum.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=8213376844065272083&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pearson-air-museum",
      "poi_latitude": "45.62393609999999",
      "poi_longitude": "-122.6562417",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-816-6232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-efdc-75f8-a92d-b2cfe47b80bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-efdc-75f8-a92d-b2cfe47b80bd",
        "storage_key": "property/6767906449166804/019d02d1-efdc-75f8-a92d-b2cfe47b80bd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJX5GokKyolVQRE_HtLLnG-3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_55864ee5-b1fa-4ec0-81db-0944496f0f40",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "FVRLibraries - Vancouver Community Library",
      "poi_type": "Education",
      "poi_address": "901 C St, Vancouver, WA 98660, USA",
      "poi_short_description": "Public library with story times and a play area, a terrace, and a plant wall.",
      "poi_long_description": "People say this library offers a wide selection of books, media, and services, including a dedicated children's floor with a play area and a computer lab. They also highlight the beautiful, clean, and spacious environment, with quiet areas for studying and working. Visitors consistently praise the staff for being friendly, helpful, and knowledgeable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-1b5e-740d-a486-60f9398d1e84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-1b5e-740d-a486-60f9398d1e84",
        "storage_key": "property/6767906449166804/01a0b628-1b5e-740d-a486-60f9398d1e84.webp",
        "width": 1280,
        "height": 880
      },
      "poi_business_url": "https://www.fvrl.org/locations/FV-VA/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3499084194712483272&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fvrlibraries---vancouver-community-library",
      "poi_latitude": "45.6284873",
      "poi_longitude": "-122.6684401",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-906-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-3dc8-71ac-8412-4df746f06a4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0b628-3dc8-71ac-8412-4df746f06a4f",
        "storage_key": "property/6767906449166804/01a0b628-3dc8-71ac-8412-4df746f06a4f.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJP8tiYrGolVQRyHUFQYk-jzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_aeae38ee-17d8-4ae6-8088-b48ac59b930f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11812 NE Fourth Plain Blvd, Vancouver, WA 98682, USA",
      "poi_short_description": "Workout chain featuring a variety of cardio equipment.",
      "poi_long_description": "People say this gym is very clean and well-maintained, offering a wide variety of modern equipment, including free weights and squat racks. They also highlight the friendly and welcoming staff, who create a positive and comfortable atmosphere.\n\nSome reviews mention some equipment can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-1b02-72ae-bf62-597b439e6820.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-1b02-72ae-bf62-597b439e6820",
        "storage_key": "property/6767906449166804/01a0b628-1b02-72ae-bf62-597b439e6820.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/vancouver-fourth-plain-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17907396263538491316&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.6687063",
      "poi_longitude": "-122.551298",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-952-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-ef1d-73dd-87d4-11d2d76b7172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ef1d-73dd-87d4-11d2d76b7172",
        "storage_key": "property/6767906449166804/019d02d1-ef1d-73dd-87d4-11d2d76b7172.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-3vmOOxlVQRtH9eNAbag_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_85fc84d7-c6d2-417b-8801-5d55aa118fa6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Eleanor Roosevelt Elementary",
      "poi_type": "Education",
      "poi_address": "2921 Falk Rd #5683, Vancouver, WA 98661, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-1b66-7474-8c21-fd25dc909c01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-1b66-7474-8c21-fd25dc909c01",
        "storage_key": "property/6767906449166804/01a0b628-1b66-7474-8c21-fd25dc909c01.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://roosevelt.vansd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15873366554738892170&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eleanor-roosevelt-elementary",
      "poi_latitude": "45.6442715",
      "poi_longitude": "-122.6274499",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-313-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e905-77bb-bd56-b5565a33d413.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e905-77bb-bd56-b5565a33d413",
        "storage_key": "property/6767906449166804/019d02d1-e905-77bb-bd56-b5565a33d413.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRQ8x222vlVQRih3H5MeGSdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e3d5673b-c13b-40f4-8747-ca79e608887c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Fort Vancouver High School Center for International Studies",
      "poi_type": "Education",
      "poi_address": "5700 E 18th St, Vancouver, WA 98661, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-1d51-77fc-970d-5d6658bb46a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-1d51-77fc-970d-5d6658bb46a0",
        "storage_key": "property/6767906449166804/01a0b628-1d51-77fc-970d-5d6658bb46a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fort.vansd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12515802546393232892&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fort-vancouver-high-school-center-for-international-studies",
      "poi_latitude": "45.6361505",
      "poi_longitude": "-122.6123217",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-313-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e905-77bb-bd56-b5565a33d413.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e905-77bb-bd56-b5565a33d413",
        "storage_key": "property/6767906449166804/019d02d1-e905-77bb-bd56-b5565a33d413.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc1ixLWOvlVQR_LWyuBoQsa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_064e9c82-889b-458b-9680-a72a9409081c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "McLoughlin Middle School",
      "poi_type": "Education",
      "poi_address": "5802 MacArthur Blvd, Vancouver, WA 98661, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-23a2-71fc-a654-458a3bd2d338.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-23a2-71fc-a654-458a3bd2d338",
        "storage_key": "property/6767906449166804/01a0b628-23a2-71fc-a654-458a3bd2d338.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://mac.vansd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4784704484270673204&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcloughlin-middle-school",
      "poi_latitude": "45.623998",
      "poi_longitude": "-122.6109791",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-313-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e905-77bb-bd56-b5565a33d413.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e905-77bb-bd56-b5565a33d413",
        "storage_key": "property/6767906449166804/019d02d1-e905-77bb-bd56-b5565a33d413.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP77x542llVQRNA0sxGCvZkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_62ac15ad-c975-4301-be7d-eae1950c1528",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Jaime’s Restaurant & Taqueria",
      "poi_type": "Restaurants",
      "poi_address": "4400 E 4th Plain Blvd, Vancouver, WA 98661, USA",
      "poi_short_description": "Laid-back restaurant serving traditional Mexican dishes, including burritos and pozole, plus beer.",
      "poi_long_description": "Diners like this restaurant's authentic Mexican food, including delicious chili rellenos, pork enchiladas, and birria, with many highlighting the fresh, handmade tortillas. They also mention the friendly, prompt service and generous portions, noting the reasonable prices offer good value.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-240f-7389-b7e7-da667448ddb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-240f-7389-b7e7-da667448ddb6",
        "storage_key": "property/6767906449166804/01a0b628-240f-7389-b7e7-da667448ddb6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://places.singleplatform.com/jaimes-restaurant--taqueria/menu?ref=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=5406050184539369564&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jaimes-restaurant--taqueria",
      "poi_latitude": "45.6397097",
      "poi_longitude": "-122.6233858",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-828-7579",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e959-7528-800e-2f7820b5b5f6",
        "storage_key": "property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJb0_MdEqvlVQRXHBnFwAmBks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6a21bc02-bc2e-48b9-90a3-b53be1f128ad",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "The Plainsman",
      "poi_type": "Restaurants",
      "poi_address": "4506 E 4th Plain Blvd, Vancouver, WA 98661, USA",
      "poi_short_description": "Hearty, homemade American meals in an unpretentious setting with a folksy atmosphere.",
      "poi_long_description": "Diners like this cafe's delicious home-style food, including homemade bread and French toast, and generous portions. They also highlight the friendly staff, welcoming atmosphere, and reasonable prices.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2665-722c-9fc8-dc1a7733ebd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2665-722c-9fc8-dc1a7733ebd6",
        "storage_key": "property/6767906449166804/01a0b628-2665-722c-9fc8-dc1a7733ebd6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://facebook.com/pages/Plainsman/156261191096948",
      "poi_directions_map_url": "https://maps.google.com/?cid=7248025137704671394&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-plainsman",
      "poi_latitude": "45.63988639999999",
      "poi_longitude": "-122.6225842",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-693-9723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e959-7528-800e-2f7820b5b5f6",
        "storage_key": "property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhxPzYmWvlVQRohj9B3YolmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_54549e46-5623-44d5-afd9-ed5868a7d80c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Silver Dragon",
      "poi_type": "Restaurants",
      "poi_address": "3605 E 4th Plain Blvd, Vancouver, WA 98661, USA",
      "poi_short_description": "Informal restaurant offering standard Chinese fare, plus vegetarian options in a utilitarian space.",
      "poi_long_description": "Diners appreciate this Chinese restaurant for its generous portions, friendly staff, and delicious sesame chicken and salt and pepper shrimp.\n\nOther reviews mention the food can be tough and overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-273d-71f8-afdc-d13c23ca1158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-273d-71f8-afdc-d13c23ca1158",
        "storage_key": "property/6767906449166804/01a0b628-273d-71f8-afdc-d13c23ca1158.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://silverdragontogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7640018296396237678&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "silver-dragon",
      "poi_latitude": "45.6371141",
      "poi_longitude": "-122.6327265",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-694-2212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e959-7528-800e-2f7820b5b5f6",
        "storage_key": "property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYiqE2ivlVQRbssueinMBmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_74a0294b-df4e-48b2-b927-f7121b710c1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Crepe house Vancouver",
      "poi_type": "Restaurants",
      "poi_address": "3405 E 4th Plain Blvd Ste C, Vancouver, WA 98661, USA",
      "poi_short_description": "false",
      "poi_long_description": "Diners like this cafe's delicious and light crepes, with many options for both sweet and savory fillings, and appreciate that they are made fresh to order. They also highlight the cozy and welcoming atmosphere, along with the friendly and attentive staff. Others mention the generous portions, often receiving two crepes per order, and the availability of a student discount.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2867-74a7-9088-a4ec4633ff23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2867-74a7-9088-a4ec4633ff23",
        "storage_key": "property/6767906449166804/01a0b628-2867-74a7-9088-a4ec4633ff23.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2706155469127925953&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crepe-house-vancouver",
      "poi_latitude": "45.637247",
      "poi_longitude": "-122.6344996",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-218-1876",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e906-7598-9fae-6c58c00afc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e906-7598-9fae-6c58c00afc28",
        "storage_key": "property/6767906449166804/019d02d1-e906-7598-9fae-6c58c00afc28.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJiQHAXRivlVQRwcBZtA8yjiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_db24da39-ed74-4e8d-badb-cdb578323353",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Hawaiian Style Grill",
      "poi_type": "Restaurants",
      "poi_address": "5000 E 4th Plain Blvd A106, Vancouver, WA 98661, USA",
      "poi_short_description": "Simple counter serve dishing out Asian-inspired, Hawaiian-style BBQ & comfort classics.",
      "poi_long_description": "Diners like this Hawaiian restaurant's delicious and authentic food, especially the Huli Huli chicken, Kalua pork, and macaroni salad, with generous portions. They also highlight the reasonable prices, welcoming atmosphere, and friendly staff.\n\nSome reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-28a4-7134-9aab-475e8d650c1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-28a4-7134-9aab-475e8d650c1f",
        "storage_key": "property/6767906449166804/01a0b628-28a4-7134-9aab-475e8d650c1f.webp",
        "width": 1177,
        "height": 663
      },
      "poi_business_url": "http://www.hawaiianstylegrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13422396819680107370&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hawaiian-style-grill",
      "poi_latitude": "45.6414415",
      "poi_longitude": "-122.6177571",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-993-5306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e959-7528-800e-2f7820b5b5f6",
        "storage_key": "property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWmdRHCvlVQRaptd58ruRbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "custom_6e416ffa-4ddd-4182-9c81-f0c729a59cf1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "MÍ CASA PUPUSERÍA Y MEXICAN RESTAURANT",
      "poi_type": "Restaurants",
      "poi_address": "3320 E 4th Plain Blvd #D, Vancouver, WA 98661, USA",
      "poi_short_description": "Unpretentious destination offering Latin American dishes, desserts & vegan options.",
      "poi_long_description": "Diners like this restaurant's delicious pupusas, fried plantains, and other authentic Salvadoran dishes. They also highlight the reasonable prices and the warm, friendly service. Others say the atmosphere is low-key and welcoming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2bed-71fa-ada6-c1903647c70b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2bed-71fa-ada6-c1903647c70b",
        "storage_key": "property/6767906449166804/01a0b628-2bed-71fa-ada6-c1903647c70b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://office.omnitech.pro/shortly/micasapupuseria",
      "poi_directions_map_url": "https://maps.google.com/?cid=1806231989913637048&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "m-casa-pupusera-y-mexican-restaurant",
      "poi_latitude": "45.6379671",
      "poi_longitude": "-122.6351603",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-984-6542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e959-7528-800e-2f7820b5b5f6",
        "storage_key": "property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2KLCKGvlVQRuNC_zGwGERk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_50c16b90-f9ba-4c4e-88d5-448cdb34eb4c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Thai Little Home",
      "poi_type": "Restaurants",
      "poi_address": "3214 E 4th Plain Blvd, Vancouver, WA 98661, USA",
      "poi_short_description": "Pint-sized Thai restaurant serving standard curries & stir-fries, with online ordering available.",
      "poi_long_description": "Diners like this restaurant's delicious and authentic Thai dishes, including flavorful curries, pad Thai, and fresh sushi. They also highlight the generous portions, reasonable prices, and quick service. Guests mention the cozy, welcoming atmosphere and friendly, attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2bde-76bb-9c65-b9b0b26ddacc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2bde-76bb-9c65-b9b0b26ddacc",
        "storage_key": "property/6767906449166804/01a0b628-2bde-76bb-9c65-b9b0b26ddacc.webp",
        "width": 1125,
        "height": 842
      },
      "poi_business_url": "http://www.tlhtogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5520954883786771806&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thai-little-home",
      "poi_latitude": "45.6378941",
      "poi_longitude": "-122.6367758",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-693-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e959-7528-800e-2f7820b5b5f6",
        "storage_key": "property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQi5i0KvlVQRXo0RLTdfnkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_beb7f7ed-a41e-4d9a-9a6e-12191fe939cb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Cecilia",
      "poi_type": "Restaurants",
      "poi_address": "2520 Columbia House Blvd #108, Vancouver, WA 98661, USA",
      "poi_short_description": "Friendly eatery offering chicken and waffles, eggs benedict, and other brunch fare.",
      "poi_long_description": "Diners like this restaurant's delicious and hearty food, with popular dishes including chicken and waffles, chilaquiles, and Abuelita's donuts. They also highlight the warm, inviting atmosphere and the friendly, attentive staff. Guests mention the reasonable prices and appreciate the complimentary donuts often offered for first-time visitors or special occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2e8b-7489-a50c-2ea3242ad1d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2e8b-7489-a50c-2ea3242ad1d7",
        "storage_key": "property/6767906449166804/01a0b628-2e8b-7489-a50c-2ea3242ad1d7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lovececilia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4753572408843544670&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cecilia",
      "poi_latitude": "45.6191266",
      "poi_longitude": "-122.6442021",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-360-4884",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e959-7528-800e-2f7820b5b5f6",
        "storage_key": "property/6767906449166804/019d02d1-e959-7528-800e-2f7820b5b5f6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZPC69ullVQRXqg3m-sU-EE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d5c4d651-76fd-4462-9674-a255deaa5976",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Bagley Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4607 Plomondon St, Vancouver, WA 98661, USA",
      "poi_short_description": "Large park featuring a baseball field and walking trails, plus a basketball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2cb0-70b5-bde0-c784e336b70c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2cb0-70b5-bde0-c784e336b70c",
        "storage_key": "property/6767906449166804/01a0b628-2cb0-70b5-bde0-c784e336b70c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15457675373916399880&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bagley-community-park",
      "poi_latitude": "45.644649",
      "poi_longitude": "-122.6238687",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-487-8177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-ef26-74cb-800c-afb94d2e2755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ef26-74cb-800c-afb94d2e2755",
        "storage_key": "property/6767906449166804/019d02d1-ef26-74cb-800c-afb94d2e2755.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj_vM9nGvlVQRCCmXs9qxhNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4f0699ad-6269-46d7-8747-a5e17d6f7f3a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Evergreen Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "E 4th Plain Blvd &, Rossiter Ln, Vancouver, WA 98661, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-2f63-7048-91cd-4a5bdf2758ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-2f63-7048-91cd-4a5bdf2758ad",
        "storage_key": "property/6767906449166804/01a0b628-2f63-7048-91cd-4a5bdf2758ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3552123734896148967&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "evergreen-park",
      "poi_latitude": "45.6374649",
      "poi_longitude": "-122.6323518",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-ef26-74cb-800c-afb94d2e2755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ef26-74cb-800c-afb94d2e2755",
        "storage_key": "property/6767906449166804/019d02d1-ef26-74cb-800c-afb94d2e2755.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQw4HWv-vlVQR5wG4iLetSzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_509f8da1-e5d7-4067-8e84-a58a9be91f27",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Meadow Homes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4798 E 18th St #4772, Vancouver, WA 98661, USA",
      "poi_short_description": "Park with multiple playgrounds, as well as a path for walking or biking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-3089-777d-a7ae-8fd6d5a02708.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-3089-777d-a7ae-8fd6d5a02708",
        "storage_key": "property/6767906449166804/01a0b628-3089-777d-a7ae-8fd6d5a02708.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofvancouver.us/parks_trails/meadow-homes-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5752374149035215078&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "meadow-homes-park",
      "poi_latitude": "45.6350328",
      "poi_longitude": "-122.6207645",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-487-8311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-ef26-74cb-800c-afb94d2e2755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ef26-74cb-800c-afb94d2e2755",
        "storage_key": "property/6767906449166804/019d02d1-ef26-74cb-800c-afb94d2e2755.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0J39mOvlVQR5khiqM-J1E8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3ddee979-db52-429d-9989-297d2530647c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Becerras International Groceries",
      "poi_type": "Shopping & Retail",
      "poi_address": "3503 E 4th Plain Blvd, Vancouver, WA 98661, USA",
      "poi_short_description": "Mexican grocery store stocking meats and other products.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-31b7-76d4-9740-a1c933fec917.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-31b7-76d4-9740-a1c933fec917",
        "storage_key": "property/6767906449166804/01a0b628-31b7-76d4-9740-a1c933fec917.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1746486380391842445&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "becerras-international-groceries",
      "poi_latitude": "45.6373085",
      "poi_longitude": "-122.6342221",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-690-0044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e92e-717e-99f7-b136fcc9f8e9",
        "storage_key": "property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Xt9H2ivlVQRjUJQFBzEPBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d33f04f8-9b99-4916-9e1c-98f852fc48f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Grocery Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "9915 NE Hazel Dell Ave, Vancouver, WA 98685, USA",
      "poi_short_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_long_description": "Shoppers say this grocery store offers clearance prices on a variety of items, including unique gourmet food items, organic produce, and an excellent wine selection. They also highlight the friendly and helpful staff, and appreciate the good customer service.\n\nSome reviews mention the accessibility can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-3033-729f-a07d-b762c0839efd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-3033-729f-a07d-b762c0839efd",
        "storage_key": "property/6767906449166804/01a0b628-3033-729f-a07d-b762c0839efd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.groceryoutlet.com/circulars/storeid/16",
      "poi_directions_map_url": "https://maps.google.com/?cid=6329547942767043957&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "grocery-outlet",
      "poi_latitude": "45.6935607",
      "poi_longitude": "-122.6673623",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-574-5155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e92e-717e-99f7-b136fcc9f8e9",
        "storage_key": "property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuyi35n2ulVQRdSVvjVES11c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4dff186d-4d56-448a-b665-d4c08fddf32f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 Grand Blvd, Vancouver, WA 98661, USA",
      "poi_short_description": "Neighborhood branch of a retailer supplying groceries and other merchandise such as electronics and clothing.",
      "poi_long_description": "Customers report that this grocery store features a wide selection of items, including fresh produce and unique frozen foods.\n\nOther reviews mention the staff can be unhelpful and display poor attitudes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-3338-7188-95fd-c82aa55a11c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-3338-7188-95fd-c82aa55a11c3",
        "storage_key": "property/6767906449166804/01a0b628-3338-7188-95fd-c82aa55a11c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3145-vancouver-wa/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16119102386726545181&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "45.6365363",
      "poi_longitude": "-122.6405951",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-258-2015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e92e-717e-99f7-b136fcc9f8e9",
        "storage_key": "property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr1hLn0OvlVQRHaf80jeOst8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5d8c1bd7-43b5-49fb-8664-bba8bfbd1554",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 Columbia House Blvd, Vancouver, WA 98661, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "People say this store offers a vast selection of groceries, home goods, and apparel, making it a convenient one-stop shop. They also highlight the clean, organized environment and the friendly, helpful staff.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-3479-73a4-b418-c153a1c85fe8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-3479-73a4-b418-c153a1c85fe8",
        "storage_key": "property/6767906449166804/01a0b628-3479-73a4-b418-c153a1c85fe8.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/wa/vancouver/grand-central/701/00683?cid=loc_70100683_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12801778384420404598&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "45.6203128",
      "poi_longitude": "-122.6451599",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-619-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e92e-717e-99f7-b136fcc9f8e9",
        "storage_key": "property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-YWUuv-llVQRdv2mKJ0NqbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_863910fd-c086-41db-92b9-a1460208a995",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "New Seasons Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1506 Main St, Vancouver, WA 98660, USA",
      "poi_short_description": "This grocery supplier with many locally sourced items also sells home goods & wellness products.",
      "poi_long_description": "People say this market offers high-quality produce, a variety of hot foods, and unique gourmet products. They also highlight the clean stores, inviting atmosphere, and friendly, knowledgeable staff.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/01a0b628-36b5-70ed-b728-0f61619fdb12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b628-36b5-70ed-b728-0f61619fdb12",
        "storage_key": "property/6767906449166804/01a0b628-36b5-70ed-b728-0f61619fdb12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newseasonsmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8236522530855888331&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "new-seasons-market",
      "poi_latitude": "45.632968",
      "poi_longitude": "-122.6718769",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-433-0752",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-e92e-717e-99f7-b136fcc9f8e9",
        "storage_key": "property/6767906449166804/019d02d1-e92e-717e-99f7-b136fcc9f8e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTe3JHpeplVQRy6UqVJoBTnI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ca0100b9-d5a1-456c-9f7c-2084e30e6171",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "poi_name": "Revolutionary Fitness Studios",
      "poi_type": "Health and Wellness",
      "poi_address": "5000 E 4th Plain Blvd e101, Vancouver, WA 98661, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=111910190751971239&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "revolutionary-fitness-studios",
      "poi_latitude": "45.6406183",
      "poi_longitude": "-122.6202836",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 360-216-6141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d1-ef1d-73dd-87d4-11d2d76b7172.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02d1-ef1d-73dd-87d4-11d2d76b7172",
        "storage_key": "property/6767906449166804/019d02d1-ef1d-73dd-87d4-11d2d76b7172.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSal6AHCvlVQRp3eEvrmVjQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    }
  ],
  "office_hours": [
    {
      "id": "custom_e31da748-981b-4237-a9e4-b3b4f4c3c064",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_516fdc96-7c60-44e5-beb9-b3d0f76f9329",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_7077e47c-236a-46f5-8643-f4aafeb0004f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_2bd9cf64-7241-44dc-9d01-b1086e2f9d75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f2f38b1b-8fa4-4d62-882f-e8a9c62c3850",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_6ee3b2d5-e1a0-4b38-8081-e9cd8bd96a57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_8af19a8f-a952-4cb1-8b49-aa0964298bf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_8ac1d045-bf85-44e2-bd14-70fbd399afaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "rating": "5.0",
      "name": "Keisha Harden",
      "text": "They havethe best maintenance teams I’ve ever encounter Kendra and Mike go above And beyond to make sure all maintenance request are completed properly and efficiently. in my book this team here deserves a five star review every time!!!",
      "date": "2025-10-23",
      "title": ""
    },
    {
      "id": "custom_403b71c4-7dd9-471b-8c40-e6751cf2a5e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "rating": "5.0",
      "name": "Chris Olen",
      "text": "I have lived at Creekside Village for almost 7 years and I have appreciated the professionalism and communication from Charlette and Jordan. Anytime I come to them with an issue it seems to be resolved. Our family enjoys living in this community and that is why we have stayed for so long!",
      "date": "2025-06-13",
      "title": ""
    },
    {
      "id": "custom_d853dc4c-aed1-4dde-a8bb-bdc25534f382",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "rating": "5",
      "name": "Austin W.",
      "text": "Jordan, Kendra, and Mike have been great to work with and we’ve really appreciated their communication throughout the move in process!",
      "date": "2026-03-15",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_b8480591a10e8049ac050ca3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d2-7450-739c-9b46-65bf0f96b986.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Community lounge area with ping pong table, foosball table, seating, and a wet bar.",
        "public_id": "019d02d2-7450-739c-9b46-65bf0f96b986",
        "storage_key": "property/6767906449166804/019d02d2-7450-739c-9b46-65bf0f96b986.webp",
        "width": 984,
        "height": 553
      },
      "virtual_tour_title": "Game Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Lt8u5n9jJQz"
    },
    {
      "id": "ec_3a462eaf949d5dd657884e92",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166804/019d02d2-7383-7256-ab85-6807e2bdcf2b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior hallway leading to a bedroom and bathroom, with a large window in the bedroom.",
        "public_id": "019d02d2-7383-7256-ab85-6807e2bdcf2b",
        "storage_key": "property/6767906449166804/019d02d2-7383-7256-ab85-6807e2bdcf2b.webp",
        "width": 984,
        "height": 553
      },
      "virtual_tour_title": "2BR, 2BA - 1,016 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2EiMm5GhFbf"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019f04c0-8b29-710e-95b7-eb402963a568",
      "lead_source": "LANDING_PAGE",
      "name": "Creekside Village Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804"
    },
    {
      "lead_collector_id": "019f04c0-8c8b-7283-ba39-50fd97a1513d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Creekside Village Website",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "page_item_url": "creekside-village-apartments-with-pool-vancouver-wa",
      "search_query": "apartments with pool Vancouver WA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Vancouver, WA",
      "h2_subtitle": "Discover premium living in Vancouver, WA at Creekside Village. Enjoy access to our refreshing pool and a host of other top-notch amenities.",
      "page_copy": "Welcome to Creekside Village, where comfort meets style in Vancouver, WA. If you're searching for apartments with pool access, look no further. Our residents enjoy the luxury of a refreshing pool along with various other amenities such as a clubhouse and spa. Nestled in the vibrant Bagley Downs neighborhood, our community offers the perfect balance of tranquility and convenience.\n\nAt Creekside Village, your comfort is our priority. With high-speed internet access and community-wide WiFi, staying connected is a breeze. Our fireplaces provide a cozy retreat during the cooler months, adding a touch of warmth to your home. Explore the perfect blend of comfort, convenience, and luxury at Creekside Village today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool | Creekside Village, Vancouver WA",
      "seo_description": "Find luxury apartments with pool access in Vancouver, WA at Creekside Village. Enjoy a clubhouse, spa, and more in the heart of Bagley Downs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "page_item_url": "creekside-village-pet-friendly-apartments-bagley-downs",
      "search_query": "pet-friendly apartments near Bagley Downs",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments Near Bagley Downs",
      "h2_subtitle": "Creekside Village offers pet-friendly living near Bagley Downs. Enjoy spacious layouts and modern amenities perfect for you and your pet.",
      "page_copy": "Welcome to Creekside Village, a haven for pet lovers searching for pet-friendly apartments near Bagley Downs. Our community embraces both you and your furry friends, ensuring a comfortable and enjoyable living experience. Located in vibrant Vancouver, WA, our spacious apartments offer modern amenities like fireplaces and high-speed internet access, ideal for all lifestyles.\n\nNestled close to the serene surroundings of Bagley Downs, you'll have plenty of opportunities for walks and outdoor play. Plus, our community features like a clubhouse and spa add luxury and convenience to apartment living. Discover the perfect blend of pet-friendly spaces and premium amenities at Creekside Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments | Creekside Village, Bagley Downs",
      "seo_description": "Find pet-friendly apartments near Bagley Downs at Creekside Village. Enjoy spacious living and amenities perfect for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "page_item_url": "creekside-village-in-unit-washer-dryer-vancouver-wa",
      "search_query": "in-unit washer dryer Vancouver WA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer in Vancouver, WA",
      "h2_subtitle": "Creekside Village provides ultimate convenience with in-unit washer and dryer in Vancouver, WA. Enjoy modern living with premium amenities.",
      "page_copy": "Discover the convenience and comfort of having an in-unit washer and dryer at Creekside Village. Located in the heart of Vancouver, WA, our apartments are designed with your needs in mind, offering modern features that enhance your lifestyle. Say goodbye to laundry day hassles and enjoy more free time using our community's wonderful amenities, such as a luxurious spa and vibrant clubhouse.\n\nCreekside Village is perfectly situated in the Bagley Downs neighborhood, bringing you closer to everything that Vancouver has to offer. Alongside the convenience of in-home laundry, you'll find community-wide WiFi and high-speed internet access that keeps you connected at all times. Enjoy a truly modern living experience at Creekside Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer Dryer | Creekside Village, Vancouver WA",
      "seo_description": "Explore apartments with in-unit washer and dryer at Creekside Village, Vancouver, WA. Enjoy modern amenities in the heart of Bagley Downs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "page_item_url": "creekside-village-dog-park-apartments-clark-county",
      "search_query": "dog park apartments Clark County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Clark County",
      "h2_subtitle": "Creekside Village offers pet-friendly living with access to nearby dog parks in Clark County. Experience quality living with your pet.",
      "page_copy": "Welcome to Creekside Village, where pet-friendly living reaches new heights in Clark County. Our apartments are ideal for dog owners, with easy access to nearby dog parks, making playtime with your furry friend a breeze. Located in the thriving community of Bagley Downs, Vancouver, WA, our spacious units ensure comfort and ample room for both you and your pet.\n\nCreekside Village is more than just a place to live; it's a community with amenities designed to enhance your lifestyle. Enjoy high-speed internet access, a clubhouse, and a relaxing spa, all while knowing you're close to natural spaces for your pet. Experience a harmonious blend of pet-friendly features and modern comforts right here at Creekside Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments | Creekside Village, Clark County",
      "seo_description": "Discover dog park apartments in Clark County at Creekside Village. Pet-friendly living with great amenities in Vancouver's Bagley Downs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "page_item_url": "creekside-village-air-conditioned-apartments-near-98661",
      "search_query": "air-conditioned apartments near 98661",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments Near 98661",
      "h2_subtitle": "Stay comfortable year-round in our air-conditioned apartments near Vancouver's 98661 area. Discover quality living at Creekside Village.",
      "page_copy": "At Creekside Village, enjoy the perfect combination of comfort and convenience with our air-conditioned apartments near the 98661 area. Nestled in the vibrant community of Bagley Downs, Vancouver, WA, our homes are designed to keep you cool and comfortable, regardless of the season. In addition to air conditioning, our apartments offer modern amenities such as fireplaces and high-speed internet access, ideal for contemporary living.\n\nLiving at Creekside Village means enjoying a lifestyle enhanced by superior community features, including a luxurious spa and a welcoming clubhouse. Conveniently located close to shopping, dining, and outdoor activities, our apartments provide the best of Vancouver while keeping you perfectly situated in the peaceful ambiance of Bagley Downs. Experience exceptional living with all the comforts of home at Creekside Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments | Creekside Village 98661",
      "seo_description": "Find air-conditioned apartments near 98661 at Creekside Village. Enjoy year-round comfort and modern amenities in Vancouver's Bagley Downs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "page_item_url": "creekside-village-two-bedroom-apartments-vancouver-wa",
      "search_query": "two bedroom apartments vancouver wa",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Vancouver, WA",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Creekside Village in Vancouver, WA. Experience convenience and modern amenities in a vibrant community.",
      "page_copy": "Located in the heart of Vancouver, WA, Creekside Village offers spacious two-bedroom apartments designed for comfortable living. With modern amenities such as high-speed internet access and a cozy fireplace, these apartments provide an ideal setting for a contemporary lifestyle. Situated within the charming Bagley Downs neighborhood, our community is surrounded by local conveniences and natural beauty.\n\nAt Creekside Village, enjoy a range of amenities, including a luxurious spa and an inviting clubhouse. Our two-bedroom apartments provide plenty of room for relaxation, entertaining, and everyday activities. Discover the perfect blend of comfort and style in a vibrant community setting at Creekside Village, where modern living meets natural charm.\n",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments | Creekside Village, Vancouver WA",
      "seo_description": "Find spacious two-bedroom apartments in Vancouver, WA at Creekside Village. Enjoy modern living with great amenities in Bagley Downs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166804",
      "source": "custom",
      "page_item_url": "creekside-village-three-bedroom-floorplans-bagley-downs",
      "search_query": "three bedroom floorplans bagley downs",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floorplans in Bagley Downs",
      "h2_subtitle": "Discover spacious three-bedroom floorplans at Creekside Village, located in the vibrant Bagley Downs neighborhood. Comfort and modern amenities await you.",
      "page_copy": "Experience spacious living at Creekside Village with our impressive three-bedroom floor plans in the heart of Bagley Downs. These apartments offer ample room for everyday living, working from home, and entertaining, along with modern amenities and conveniences. Each apartment is designed for comfort, from cozy fireplaces to high-speed internet access, supporting a variety of daily routines.\n\nCreekside Village is more than just a place to live; it’s a community filled with features designed to enhance your experience. Residents enjoy access to a welcoming clubhouse, community-wide Wi-Fi, and a relaxing spa, all within the vibrant Bagley Downs area. If you’re looking for additional space and a setting that combines comfort and style, our three-bedroom floor plans offer an excellent option.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floorplans | Creekside Village, Bagley Downs",
      "seo_description": "Explore three-bedroom floorplans in Bagley Downs at Creekside Village. Enjoy spacious living and modern amenities in this vibrant Vancouver community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5619"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11557768514"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PCS86LZD"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Pathfinder 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Pathfinder Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "481CSV"
    },
    {
      "ID": "custom_anyonehome_chatbot",
      "type": "STRING",
      "value": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('5vRNVhfKoEcT9JtWue')</script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40343719840"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rxwj5e0xv1e"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "22009716"
    },
    {
      "ID": "custom_website_tracking_email",
      "type": "STRING",
      "value": "amcllc_creeksidevillage_web_propertywebsite@leads.anyonehome.com"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Creekside Village/scheduletourwidget/P1WjM5TnXQSstF8g2M/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlpoemJleG9KQUVteGhLS3dCeUVTRGc9PSIsInZhbHVlIjoid21yRDA2V0Y2UUVUb1JaVzg0MG9MUT09IiwibWFjIjoiNmQyM2JiYjY4NmMzZDQ5MzMxNTUxMjM4YTVlNDc2ZTA3YmMzMWVlM2ZhMmRiNTA2MTQwOTJiZjIwMjg1YmVjNyJ9"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "5619",
  "custom_repli_id": "11557768514",
  "custom_google_gtm_id": "GTM-PCS86LZD",
  "custom_rollout_phase": "Pathfinder 2",
  "custom_vibesites_theme": "Pathfinder Preferred",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_aim_property_code": "481CSV",
  "custom_anyonehome_chatbot": "<link rel='stylesheet' href='https://www.myshowing.com/css/omnichannel/omnichannel_communication.css'> <script src='https://www.myshowing.com/js/omnichannel/omnichannel_communication.js'></script><script text='text/javascript'>window.OmniChannel.init('5vRNVhfKoEcT9JtWue')</script>",
  "custom_hubspot_company_id": "40343719840",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/rxwj5e0xv1e",
  "custom_website_subscription": "turnkey",
  "custom_broker_license_number": "22009716",
  "custom_website_tracking_email": "amcllc_creeksidevillage_web_propertywebsite@leads.anyonehome.com",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Creekside Village/scheduletourwidget/P1WjM5TnXQSstF8g2M/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlpoemJleG9KQUVteGhLS3dCeUVTRGc9PSIsInZhbHVlIjoid21yRDA2V0Y2UUVUb1JaVzg0MG9MUT09IiwibWFjIjoiNmQyM2JiYjY4NmMzZDQ5MzMxNTUxMjM4YTVlNDc2ZTA3YmMzMWVlM2ZhMmRiNTA2MTQwOTJiZjIwMjg1YmVjNyJ9",
  "custom_audioeye_site_id": "74e7bfc1-fd0a-4f9b-8c5c-83ee9b7a2d01",
  "custom_audioeye_site_hash": "604f54de5cdb7f9983762fcbd318dc1d"
};

export const generatedAt = '2026-11-03T21:34:40.208Z';
